"use strict";

window.theme = window.theme || {};

// Customer :: My Account
theme.CustomerAccount = (function(){
  function CustomerAccount(container){
  }

  return CustomerAccount;
})();

// Customer :: Addresses
theme.CustomerAddresses = (function(){
  var selectors = {
    addressList: "[data-address-list]",
    address: "[data-adddress]",
    toggleAddressFormCTA: "[data-address-form-toggle-cta]",
    editAddressCTA: "[data-address-edit-cta]",
    deleteAddressCTA: "[data-address-delete-cta]",
    addressJson: "[data-address-json]",
    loader: "[data-loader]",

    form: "[data-address-form-container] form",
    formContainer: "[data-address-form-container]",
    formSubmitCTA: "[data-address-form-container] [data-form-submit-btn]",
    input_method: '[data-address-form-container] [name="_method"]',
    country: '[data-address-form-container] [name="address[country]"]',
    province: '[data-address-form-container] [name="address[province]"]',

    noResult: "[data-account-modal-noresult]"
  };

  var cache = {
    newAddressUrl: "/account/addresses",
    addressPageUrl: "/account/addresses"
  };

  function CustomerAddresses(container){
    this.container = container;
    this.eventHandlers = {};

    this.init();
  }

  CustomerAddresses.prototype.init = function(){
    this.bindAddressEvents();
    this.initFormEvents();
  }
  
  CustomerAddresses.prototype.initFormEvents = function(destroy){
    this.setupCountries();
    var fields=[{id:"#form-address-FirstName",name:"address[first_name]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 3 caractere"}},{id:"#form-address-phone",name:"address[phone]",optional:!1,regex:/^0[1-9]{1}[0-9]{8}$/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numarul de telefon nu este corect. Introdu 10 cifre, incepand cu 0"}},{id:"#form-address-City",name:"address[city]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 3 caractere"}},{id:"#form-address-Zip",name:"address[zip]",optional:!1,regex:/(?=.{6,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"codul postal trebuie sa contina minim 6 cifre"}}];
    this.FormObj = new theme.InitForm("[data-address-block] [data-address-form-container]", fields, true);
  
    this.eventHandlers.submitForm = this.submitForm.bind(this);
    var formSubmitCTA = this.DOMSelector(selectors.formSubmitCTA);
    formSubmitCTA.addEventListener("click", this.eventHandlers.submitForm, false);
  }

  CustomerAddresses.prototype.bindAddressEvents = function(destroy){
    if(!destroy){
      this.eventHandlers.toggleAddressForm = this.toggleAddressForm.bind(this);
      this.eventHandlers.editAddress = this.editAddress.bind(this);
      this.eventHandlers.deleteAddress = this.deleteAddress.bind(this);
    }

    var toggleAddressFormCTA = this.DOMSelector(selectors.toggleAddressFormCTA, 1);
    var editAddressCTA = this.DOMSelector(selectors.editAddressCTA, 1);
    var deleteAddressCTA = this.DOMSelector(selectors.deleteAddressCTA, 1);

    // Toggle Address Form
    toggleAddressFormCTA.forEach(function (btn, index) {
      if(destroy) btn.removeEventListener("click", this.eventHandlers.toggleAddressForm, false);
      else btn.addEventListener("click", this.eventHandlers.toggleAddressForm, false);
    }, this);

    // Edit Address Form
    editAddressCTA.forEach(function (btn, index) {
      if(destroy) btn.removeEventListener("click", this.eventHandlers.editAddress, false);
      else btn.addEventListener("click", this.eventHandlers.editAddress, false);
    }, this);

    // Delete Address Form
    deleteAddressCTA.forEach(function (btn, index) {
      if(destroy) btn.removeEventListener("click", this.eventHandlers.deleteAddress, false);
      else btn.addEventListener("click", this.eventHandlers.deleteAddress, false);
    }, this);
  }

  CustomerAddresses.prototype.DOMSelector = function(selector, all){
    if(!selector) return null;

    if(all) return this.container.querySelectorAll(selector);
    else return this.container.querySelector(selector);
  }

  CustomerAddresses.prototype.showLoading = function(show){
    var formSubmitCTA = this.DOMSelector(selectors.formSubmitCTA);
    if(show){
      formSubmitCTA.querySelector('[data-text]').classList.add('hide');
      formSubmitCTA.querySelector('[data-loader]').classList.remove('hide');
      formSubmitCTA.disabled = true;
    } else {
      formSubmitCTA.querySelector('[data-text]').classList.remove('hide');
      formSubmitCTA.querySelector('[data-loader]').classList.add('hide');
      formSubmitCTA.disabled = false;
    }
  };

  CustomerAddresses.prototype.buildForm = function (target, attributes) {
    /*
    target = url || form action url
    attributes = {
      method:'post' || 'get',
      parameters: {
        _method:'delete' || 'put'
      }
    }
  */
    var method = (attributes = attributes || {}).method || "post";
    var parameters = attributes.parameters || {};
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", target);

    for (var param in parameters) {
        var input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", param);
        input.setAttribute("value", parameters[param]);
        form.appendChild(input);
    }
    
    return form;
  };

  CustomerAddresses.prototype.setupCountries = function () {
    var Country = this.DOMSelector(selectors.country);
    var Province = this.DOMSelector(selectors.province);
    if (Country && Province && Shopify && Shopify.CountryProvinceSelector) {
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector("form-address-Country", "form-address-Province", {
            hideElement: "AddressProvinceContainerNew",
        });
    }
  };

  CustomerAddresses.prototype.toggleAddressForm = function (evt) {
    var addressList = this.DOMSelector(selectors.addressList);
    var formContainer = this.DOMSelector(selectors.formContainer);
    if(evt){
      var form = this.DOMSelector(selectors.form);
      form.method = "post";
      form.type = "post";
      form.action = cache.newAddressUrl;
      this.setForm(form);
    }
  
    addressList.classList.toggle("hidden");
    formContainer.classList.toggle("hidden");
  };

  CustomerAddresses.prototype.setForm = function (form, addressJson) {
    if (!form) return;
    
    if (!addressJson) {
        addressJson = {};
        var input_method = form.querySelector(selectors.input_method);
        input_method && form.removeChild(input_method);
    } else {
        var input_method = document.createElement("input");
        input_method.type = "hidden";
        input_method.name = "_method";
        input_method.value = "put";
        form.appendChild(input_method);
    }

    if (this.FormObj) this.FormObj._resetForm();

    var FirstName = form.querySelector("#form-address-FirstName");
    FirstName.value = addressJson.first_name || "";
    var Phone = form.querySelector("#form-address-phone");
    Phone.value = addressJson.phone || "";
    var Company = form.querySelector("#form-address-Company");
    Company.value = addressJson.company || "";
    var Address1 = form.querySelector("#form-address-Address1");
    Address1.value = addressJson.address1 || "";
    var Address2 = form.querySelector("#form-address-Address2");
    Address2.value = addressJson.address2 || "";
    var City = form.querySelector("#form-address-City");
    City.value = addressJson.city || "";
    var Zip = form.querySelector("#form-address-Zip");
    Zip.value = addressJson.zip || "";
    var DefaultAddress = form.querySelector("#form-address_default_address_consent");
    if (addressJson.default) DefaultAddress.checked = true;
    else DefaultAddress.checked = false;

    var Country = form.querySelector("#form-address-Country");
    var Province = form.querySelector("#form-address-Province");
    if (addressJson.country) {
        Country.value = addressJson.country;
        Country.dispatchEvent(new Event("change"));
        setTimeout(function () {
            Province.value = addressJson.province;
            Province.dispatchEvent(new Event("change"));
        }, 500);
    } else {
        Country.value = Country.children[0].value;
        Country.dispatchEvent(new Event("change"));
    }
  };

  CustomerAddresses.prototype.formSuccessCB = function (res) {
    var self = this;
    var body = theme.Helpers.stringToHTML(res);
    var addressList = this.DOMSelector(selectors.addressList);
    var noResult = this.DOMSelector(selectors.noResult);

    var isLoggedOut = body.classList.contains('template-customers-login');
    if(isLoggedOut){
        alert('Esti deconectat, trebuie sa te autentifici.');
        window.location.href = '/account/login';
        return;
    }

    fetch(cache.addressPageUrl).then(function(res){
      return res.text();
    }).then(function(html_str) {
      var body = theme.Helpers.stringToHTML(html_str);
      var addressListHtml = body.querySelector('[data-address-list]').innerHTML;
      addressList.innerHTML = addressListHtml;
      addressList.classList.add("block");
      addressList.classList.remove("flex");
      noResult.classList.add("hidden");
      self.showLoading(0);
      self.bindAddressEvents(1); // Destroy Address Events
      self.bindAddressEvents(0); // Re-initialize Address Events
      self.toggleAddressForm();
    }).catch(function(err){
      console.log(err);
    });
  };

  CustomerAddresses.prototype.formFailCB = function (err) {
      console.error("Error", err);
      this.showLoading(0);
      alert("Ceva n-a mers bine, pagina se va reincarca");
      window.location.reload();
  };

  CustomerAddresses.prototype.editAddress = function (evt) {
    var currentTarget = evt.currentTarget;
    var address = currentTarget.closest(selectors.address);
    var addressURL = address.dataset.addressUrl;

    if (addressURL) {
        var form = this.DOMSelector(selectors.form);
        var addressJson = JSON.parse(address.querySelector(selectors.addressJson).innerHTML);
        this.setForm(form, addressJson[0]);
        form.method = "post";
        form.type = "put";
        form.action = addressURL;
        this.toggleAddressForm();
    }
  };

  CustomerAddresses.prototype.deleteAddress = function (evt) {
    var self = this;
    var currentTarget = evt.currentTarget;
    var addressList = this.DOMSelector(selectors.addressList);
    var noResult = this.DOMSelector(selectors.noResult);

    currentTarget.querySelector(selectors.loader).classList.remove("hidden");
    var addressDeleteCta = currentTarget.dataset.addressDeleteCta;
    if (addressDeleteCta != null && addressDeleteCta != undefined) {
        if (confirm(currentTarget.getAttribute("data-confirm-message"))) {
            var form = this.buildForm(currentTarget.dataset.target, {
                parameters: { _method: "delete", return_to: "/account" },
            });
            theme.submitFormViaAjax({
                form: form,
                type: "DELETE",
                successCB: function (res) {
                    currentTarget.querySelector(selectors.loader).classList.add("hidden");
                    currentTarget.closest(selectors.address).remove();
                    var addresses = self.DOMSelector(selectors.address, 1);
                    if (!addresses || addresses.length === 0) {
                        addressList.classList.remove("block");
                        addressList.classList.add("flex");
                        noResult.classList.remove("hidden");
                    }
                },
                errorCB: self.formFailCB,
            });
        } else {
            currentTarget.querySelector(selectors.loader).classList.add("hidden");
        }
    }
  };

  CustomerAddresses.prototype.submitForm = function(evt){
    evt.preventDefault();
    var self = this;
    var res = this.FormObj._validateForm();
    
    if(res.status){
        this.showLoading(1);
        theme.submitFormViaAjax({
            form: self.FormObj.form,
            successCB: self.formSuccessCB.bind(self),
            errorCB: self.formFailCB.bind(self),
        });
    } else {
      console.error('Invalid Form');
    }
  };

  return CustomerAddresses;
})();

// Customer :: Order
theme.CustomerOrder = (function(){
  var selectors = {
    orderAddToCart: "[data-add-to-cart]",
    orderJson: "[data-order-json]",
  };

  function CustomerOrder(container){
    this.container = container;
    this.eventHandlers = {};

    this.init();
  }

  CustomerOrder.prototype.init = function(){
    var orderAddToCart = this.DOMSelector(selectors.orderAddToCart);
    this.eventHandlers.orderAddToCart = this.orderAddToCart.bind(this);

    orderAddToCart.addEventListener("click", this.eventHandlers.orderAddToCart, false);
  };

  CustomerOrder.prototype.DOMSelector = function(selector, all){
    if(!selector) return null;

    if(all) return this.container.querySelectorAll(selector);
    else return this.container.querySelector(selector);
  };

  CustomerOrder.prototype.showLoading = function(show){
    var orderAddToCart = this.DOMSelector(selectors.orderAddToCart);
    if(show){
      orderAddToCart.querySelector('[data-text]').classList.add('hide');
      orderAddToCart.querySelector('[data-loader]').classList.remove('hide');
      orderAddToCart.disabled = true;
    } else {
      orderAddToCart.querySelector('[data-text]').classList.remove('hide');
      orderAddToCart.querySelector('[data-loader]').classList.add('hide');
      orderAddToCart.disabled = false;
    }
  };

  CustomerOrder.prototype.orderAddToCart = function (evt) {
    evt.preventDefault();
    var self = this, orderJson = null;
    this.showLoading(1);

    try {
      orderJson = this.DOMSelector(selectors.orderJson).innerHTML;
      orderJson = JSON.parse(orderJson);
    } catch(err) {
      console.error(err);
    }
    
    if(orderJson){
      var formData = { items: orderJson };
      window.AjaxCart.addItems(
        formData,
        function () {self.showLoading(0)},
        function () {self.showLoading(0)}
      );
    }
  };

  return CustomerOrder;
})();

// Activate Account Page
theme.ActivateAccountOrResetPswd = (function(){

  function ActivateAccountOrResetPswd(container){
    if(container.classList.contains('activate-account')){
      this.parentElem = '.template-customers-activate_account .activate-account';
    }
    if(container.classList.contains('reset-password')){
      this.parentElem = '.template-customers-reset_password .reset-password';
    }
    this.init();
  }

  ActivateAccountOrResetPswd.prototype.init = function(){
    var fields = [
      {
        id: "#CustomerPassword",
        name: "customer[password]",
        optional: false,
        regex: /^(?=.*[0-9])(?=.{6,})[a-zA-Z0-9!@#$%^&*]{6,16}$/,
        depend: null,
        error: {
            empty: "Acest camp este obligatoriu",
            condition: "Parola invalida, trebuie sa contina minum un numar si cel putin 6 caractere"
        }
      },
      {
        id: "#CustomerPasswordConfirmation",
        name: "customer[password_confirmation]",
        optional: false,
        regex: null,
        depend: {
          id: "#CustomerPassword",
          optional: false,
          regex: /^(?=.*[0-9])(?=.{6,})[a-zA-Z0-9!@#$%^&*]{6,16}$/,
          matchValue: true,
          error: {
            empty: "Acest camp este obligatoriu",
            condition: "Parola invalida, trebuie sa contina minum un numar si cel putin 6 caractere"
          }
        },
        error: {
            empty: "Acest camp este obligatoriu",
            condition: "Parolele nu sunt identice"
        }
      }
    ];
    
    new theme.InitForm(this.parentElem, fields);
  }

  return ActivateAccountOrResetPswd;
})();

/* 
* Submit Form via Ajax
* Response will be html string
*/
theme.submitFormViaAjax = function (data) {
    var form = data.form;
    var type = data.type || form.type || "POST";
    var successCB = data.successCB;
    var errorCB = data.errorCB;

    var URL = form.action;
    var method = form.method || "POST";

    if (!form || !URL) {
        throw new Error("Invalid Request Data");
        return;
    }

    var jqxhr = $.ajax({
        url: URL,
        type: type,
        method: method,
        data: $(form).serialize(),
        //dataType:'jsonp'
    })
        .done(function (res) {
            if (successCB && typeof successCB === "function") successCB(res);
        })
        .fail(function (err) {
            if (errorCB && typeof errorCB === "function") errorCB(err);
        })
        .always(function () {
        });
};

// Ajax Cart - Add Single or Multiple Items to Cart via Ajax
theme.AjaxCart = (function () {
    function AjaxCart() {}

    AjaxCart.prototype.addItems = function (items, successCB, errorCB) {
        if (!items) return;

        fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(items),
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                window.miniCart._updateCartPopupContent(json, function (cart) {
                    if (successCB && typeof successCB === "function") {
                        successCB(cart);
                        setTimeout(function () {
                            window.miniCart._hideCartPopup();
                        }, 3000);
                    }
                });
            })
            .catch(function (error) {
                console.error("Error:", error);
                if (errorCB && typeof errorCB === "function") {
                    errorCB(error);
                }
                window.miniCart._hideCartPopup();
            });
    };

    return AjaxCart;
})();

// Bottom to top scroll CTA
// When the user clicks on the button, scroll to the top of the document
theme.backToTop = (function(){
    var backToTop = document.querySelector('.btn-back-to-top');
    if(backToTop){
        function topFunction() {
            window.scroll({top: 0, behavior: "smooth"});
        }
        function handleScroll(){
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                backToTop.style.display = "block";
            } else {
                backToTop.style.display = "none";
            }
        }
        window.onscroll = handleScroll;
        backToTop.addEventListener('click', topFunction);
    }
})();

// Contact Page
theme.Contact = (function(){
  var selectors = {
    btnSubmit:'[data-form-submit-btn]',
    resWrapper: '[data-res-wrapper]'
  };

  var cache = {
    gdpr_api_url: apiBaseUrl + '/api/customer/gdpr'
  };
  function Contact(container){
    this.container = container;

    this.init();
  }

  Contact.prototype.init = function(){
    var fields=[{id:"#ContactForm-FirstName",name:"contact[first_name]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 3 caractere"}},{id:"#ContactForm-phone",name:"contact[phone]",optional:!1,regex:/^0[1-9]{1}[0-9]{8}$/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numarul de telefon nu este corect. Introdu 10 cifre, incepand cu 0"}},{id:"#ContactForm-email",name:"contact[email]",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Campul e-mail nu este corect"}},{id:"#send_to",name:"contact[send_to]",optional:!1,regex:null,depend:null,error:{empty:"Campul Trimite la este obligatoriu",condition:"Campul Trimite la este obligatoriu"}},{id:"#ContactForm-subject",name:"contact[subject]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Subiect trebuie sa contina minim 3 caractere"}},{id:"#ContactForm-body",name:"contact[body]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Mesaj trebuie sa contina minim 3 caractere"}},{id:"#terms_consent",name:"contact[T&C_true]",optional:!1,regex:null,depend:null,error:null}];
    this.formObj = new theme.InitForm('.contact-form-wrapper',fields, true);
    
    if(window.location.search && window.location.search.indexOf('?contact_posted=true') > -1){
      history.replaceState('','','/pages/contact');
    }

     // Submit Form
     this.btnSubmit = this.container.querySelector(selectors.btnSubmit);
     this.btnSubmit.addEventListener('click', this.submitForm.bind(this));
  }

  Contact.prototype.showLoading = function(show){
    if(show){
      this.btnSubmit.querySelector('[data-text]').classList.add('hide');
      this.btnSubmit.querySelector('[data-loader]').classList.remove('hide');
      this.btnSubmit.disabled = true;
    } else {
      this.btnSubmit.querySelector('[data-text]').classList.remove('hide');
      this.btnSubmit.querySelector('[data-loader]').classList.add('hide');
      this.btnSubmit.disabled = false;
    }
  }

  Contact.prototype.runMiddleware = function(res){
    var self = this;
    this.showLoading(1);
    var ss = this.formObj.form.querySelector('[name="x-shopify_sstr"]').value;
    var tt = this.formObj.form.querySelector('[name="x-shopify_time"]').value;
    var accept_marketing = this.formObj.form.querySelector('#gdpr_consent').checked;

    var data = {
      "form": "contact",
      "timestamp": tt,
      "agreements": accept_marketing ? ["accepts_tc","newsletter"]: ["accepts_tc"]
    };

    res.data.forEach(function(obj){
      var name = obj.field.name;
      var value = obj.field.value;
      if(name.indexOf('first_name') > -1){
        data.name = value
      }
      if(name.indexOf('email') > -1){
        data.email = value
      }
    });

    var meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(cache.gdpr_api_url, meta).then(function(res){
      if(res.ok){
        return res;
      } else {
        return res.json();
      }
    }).then(function(json){
      if(json.error){
        self.displayResponse(json); 
      }
      self.formObj.form.submit();
      self.showLoading(0);
    }).catch(function(err){
      self.showLoading(0);
      self.formObj.form.submit();
    });
  }

  Contact.prototype.displayResponse = function(json){
    var message = json.message;
    if(json.error || json.status === 400){
      var tempDiv = document.createElement('div');
      if(Array.isArray(message)){
        message.map(function(msg){
          var div = document.createElement('div');
          div.textContent = msg;
          tempDiv.appendChild(div);
        });
      } else {
        if(typeof message === 'string'){
          var div = document.createElement('div');
          div.textContent = message;
          tempDiv.appendChild(div);
        }
      }

      this.showHideResponse(1, tempDiv.innerHTML);
    }
  }

  Contact.prototype.showHideResponse = function(show, msg, success){
    var resWrapper = this.container.querySelector(selectors.resWrapper);
    if(msg) resWrapper.innerHTML = msg;
    if(success){
      resWrapper.classList.remove('bg-red-light');
      resWrapper.classList.add('bg-blue-light');
    } else {
      resWrapper.classList.add('bg-red-light');
      resWrapper.classList.remove('bg-blue-light');
    }

    if(show) resWrapper.classList.remove('hidden'); 
    else resWrapper.classList.add('hidden'); 
  }

  Contact.prototype.submitForm = function(evt){
    evt.preventDefault();
    var res = this.formObj._validateForm();
    if(res.status){
      this.runMiddleware(res);
    } else {
      // console.error('Invalid Form', res, this.formObj.form);
    }
  }

  return Contact;
})();

// Return form
theme.ReturnForm = (function () {
  const selectors = {
    email: '#ReturForm-email',
    fullName: '#ReturForm-FullName',
    submitButton: '[data-form-submit-btn]',
    resWrapper: '[data-res-wrapper]',
    ordersDropdown: '[data-orders-select]',
    qtyInputs: '[data-quantity-input]',
    orderParents: '[data-order-parent]',
    productsMessage: '#ReturForm-ProductsMessage',
    totalProducts: '#ReturForm-TotalProducts',
    marketing: '#ReturForm-Marketing'
  };

  const cache = {
    gdpr_api_url: apiBaseUrl + '/api/customer/gdpr'
  };

  function ReturnForm(container) {
    this.container = container;
    this.init();
  }

  ReturnForm.prototype.init = function () {
    const self = this;
    const fields = [{
      id: selectors.fullName,
      name: "contact[full_name]",
      optional: !1,
      regex: /(?=.{3,})/,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Numele trebuie sa contina minim 3 caractere"}
    }, {
      id: "#ReturForm-phone",
      name: "contact[phone]",
      optional: !1,
      regex: null,
      depend: null,
      error: {
        empty: "Acest camp este obligatoriu",
        condition: "Acest camp este obligatoriu"
      }
    }, {
      id: selectors.email,
      name: "contact[email]",
      optional: !1,
      regex: /\S+@\S+\.\S+/,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Campul e-mail nu este corect"}
    }, {
      id: "#ReturForm-reason",
      name: "contact[reason]",
      optional: !1,
      regex: null,
      depend: null,
      error: {empty: "Motivul returului la este obligatoriu", condition: "Motivul returului la este obligatoriu"}
    }, {
      id: "#ReturForm-iban",
      name: "contact[iban]",
      optional: !1,
      regex: /(?=.{24,})/,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Acest camp trebuie sa contina 24 de caractere"}
    }, {
      id: "#ReturForm-ibanOwner",
      name: "contact[iban_owner]",
      optional: !1,
      regex: /(?=.{3,})/,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Numele detinatorului trebuie sa contina minim 3 caractere"}
    }, {
      id: "#ReturForm-OrderNo",
      name: "contact[order_no]",
      optional: !1,
      regex: null,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Acest camp este obligatoriu"}
    }, {
      id: "#ReturForm-TermsConsent",
      name: "contact[T&C_true]",
      optional: !1,
      regex: null,
      depend: null,
      error: {empty: "Acest camp este obligatoriu", condition: "Acest camp este obligatoriu"}
    }];

    if (this.container.querySelector(selectors.productsMessage)) {
      fields.push({
        id: selectors.productsMessage,
        name: "contact[products_message]",
        optional: !1,
        regex: null,
        depend: null,
        error: {empty: "Acest camp este obligatoriu", condition: "Acest camp este obligatoriu"}
      });
    }

    if (this.container.querySelector(selectors.totalProducts)) {
      fields.push({
        id: selectors.totalProducts,
        name: "contact[products]",
        optional: !1,
        regex: /(?=.{1,})/,
        depend: null,
        error: {empty: "Selecteaza minim un produs", condition: "Selecteaza minim un produs"}
      });
    }
    
    this.formObj = new theme.InitForm('.return-form-wrapper', fields, true);

    if (window.location.search && window.location.search.indexOf('?contact_posted=true') > -1) {
      history.replaceState('', '', '/pages/formular-retur');
    }

    const ordersDropdown = this.container.querySelector(selectors.ordersDropdown);
    ordersDropdown && ordersDropdown.addEventListener('change', function(event) {
      self.toggleOrder(event.target.value);
    });

    const qtyInputs = this.container.querySelectorAll(selectors.qtyInputs);
    qtyInputs && qtyInputs.forEach((input) => {
      input.addEventListener('input', function (event) {
        self.minMax(event.target);
        self.totalProducts()
      })
    });

    // Submit Form
    this.submitButton = this.container.querySelector(selectors.submitButton);
    if (this.submitButton) this.submitButton.addEventListener('click', this.submitForm.bind(this));
  }

  ReturnForm.prototype.toggleOrder = function (order) {
    const qtyInputs = this.container.querySelectorAll(selectors.qtyInputs);
    qtyInputs.forEach((input) => {
      if (input.getAttribute('data-order') !== order) {
        input.setAttribute('disabled', true)
      } else {
        input.removeAttribute('disabled');
      }
    })
    this.totalProducts()

    const orderParents = this.container.querySelectorAll(selectors.orderParents);
    orderParents.forEach((parent) => {
      parent.classList.toggle('hidden', parent.getAttribute('data-order') !== order);
    })
  }

  ReturnForm.prototype.totalProducts = function () {
    const qtyInputs = this.container.querySelectorAll(selectors.qtyInputs);
    let quantity = 0;
    qtyInputs.forEach((input) => {
      const isDisabled = input.getAttribute('disabled');
      if (isDisabled) return;
      quantity += parseInt(input.value);
    })
    
    const totalProducts = this.container.querySelector(selectors.totalProducts);
    /*Set the input's quantity to an empty string if 0*/
    totalProducts.value = quantity || '';
  }

  ReturnForm.prototype.minMax = function (input) {
    const currentValue = parseInt(input.value || 0);
    /*Format the input's value*/
    input.value = currentValue;
    const maxValue = input.getAttribute('max');
    const minValue = input.getAttribute('min');
    /*Adjust it between min and max values*/
    if (currentValue > maxValue) input.value = maxValue;
    if (currentValue < minValue) input.value = minValue;
  }

  ReturnForm.prototype.runMiddleware = function () {
    this.showLoading();
    const ss = this.container.querySelector('[name="x-shopify_sstr"]').value;
    const tt = this.container.querySelector('[name="x-shopify_time"]').value;
    const marketingConsent = this.container.querySelector(selectors.marketing).checked;

    const data = {
      'name': this.container.querySelector(selectors.fullName).value,
      'email': this.container.querySelector(selectors.email).value,
      'form': 'contact',
      'timestamp': tt,
      'agreements': marketingConsent ? ['accepts_tc', 'newsletter'] : ['accepts_tc']
    };

    const meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(cache.gdpr_api_url, meta).then(function (res) {
      if (res.ok) {
        return res;
      } else {
        return res.json();
      }
    }).then(function (json) {
      if (json.error) {
        console.log(json.error);
      }
    }).finally(() => {
      const qtyInputs = this.container.querySelectorAll(selectors.qtyInputs);
      qtyInputs && qtyInputs.forEach((input) => {
        const inputValue = parseInt(input.value || 0);
        if (inputValue === 0) input.setAttribute('disabled', true);
      });
      
      this.formObj.form.submit();
    });
  }

  ReturnForm.prototype.showLoading = function (show = true) {
    this.submitButton.querySelector('[data-text]').classList.toggle('hide', show);
    this.submitButton.querySelector('[data-loader]').classList.toggle('hide', !show);
    if (show) {
      this.submitButton.setAttribute('disabled', true)
    } else {
      this.submitButton.removeAttribute('disabled');
    }
  }

  ReturnForm.prototype.submitForm = function (event) {
    event.preventDefault();
    const res = this.formObj._validateForm();
    if (res.status) {
      this.runMiddleware();
    }
  }

  return ReturnForm;
})();

// Blog Glosar Page
theme.Glosar = (function(){
    var selectors = {
      container:'body.template-glosar',
      searchInput:'[data-search]',
      searchAutoComplete:'[data-search-autocomplete]',
  
      search_result:{
        search_term:'[data-search-terms]',
        result_wrapper:'[data-search-result]',
        goBack:'[data-go-back]',
        goBackTxt:'[data-go-back] .capitalize'
      }
    };
  
    var cache = {
      LIMIT: 6,
      blogUrl: '',
      searchResultUrl:'/pages/glosar-search',
      blogView:'glosar'
    };

    function Glosar(container){
      if(!container) return;
  
      var type = container.dataset.sectionType;
      this.container = container;
      this.eventHandlers = {};
  
      if(type === 'section-glosar'){
        cache.isGlosarPage = true;
        this.searchInput = this.container.querySelector(selectors.searchInput);
        this.searchAutoComplete = this.container.querySelector(selectors.searchAutoComplete);
        
        if(!this.container || !this.searchInput){
          throw new Error('Invalid Container or Search');
          return;
        }
  
        cache.handle = this.container.dataset.handle;
        if(!cache.handle) return;
    
        this.initGlosar();
      }
  
      if(type === 'section-glosar-search'){
        this.search_term = this.container.querySelector(selectors.search_result.search_term);
        this.result_wrapper = this.container.querySelector(selectors.search_result.result_wrapper);
        cache.isGlosarSearchPage = true;
        this.initGlosarSearch();
      }
  
    }
  
    Glosar.prototype.initGlosarSearch = function(){
      cache.handle = theme.Helpers.getParamFromURL('handle');
      var q = theme.Helpers.getParamFromURL('q');
      if(!cache.handle || !q) return;
      var self = this;
      
      this.container.querySelector(selectors.search_result.goBack).href = '/blogs/' + cache.handle;
      this.container.querySelector(selectors.search_result.goBackTxt).innerHTML = cache.handle.replace('-',' ');
      this.search_term.innerHTML = q;
      
      this.search_term.classList.remove('skelton-md');
      this.eventHandlers.autoComplete = this.autoComplete.bind(this);
  
      this.fetchData(function(){
        self.eventHandlers.autoComplete(q);
      });
    }
  
    Glosar.prototype.initGlosar = function(){
      this.eventHandlers.initEvents = this.initEvents.bind(this);
      this.fetchData(this.eventHandlers.initEvents);
    }
  
    Glosar.prototype.fetchData = function(callBack){
      var self = this;
      cache.blogUrl = '/blogs/' + cache.handle + '?view=' + cache.blogView;
  
      fetch(cache.blogUrl)
      .then(function(res) {
        return res.text();
      })
      .then(function(str){
        var body = theme.Helpers.stringToHTML(str);
        var strJson = body.querySelector('[data-script]').innerHTML;
        var arts_arr = JSON.parse(strJson).articles;
        cache.articles = arts_arr;
  
        if(callBack && typeof callBack === 'function'){
          callBack();
        }
      })
      .catch(function(err){
        console.log(err);
      })
    }
    
    Glosar.prototype.initEvents = function(){
      var self = this;
      this.eventHandlers.autoComplete = this.autoComplete.bind(this);
      this.eventHandlers.debounceInput = theme.Helpers.debounce(function(){
        var q = self.searchInput.value.trim().toLowerCase();
        if(!q || q.length < 2){
          self.searchAutoComplete.innerHTML = '';
        } else {
          self.eventHandlers.autoComplete(q);
        }
      },300);
      this.searchInput.addEventListener('input', this.eventHandlers.debounceInput);
    
      theme.Helpers.addListenerMulti(this.searchInput,'focus blur', this.toggleAutoComplete.bind(this));
    }
  
    Glosar.prototype.toggleAutoComplete = function(evt){
      var type = evt.type;
      if(type === 'focus') this.searchAutoComplete.classList.remove('hidden');
      else {
        setTimeout(function(){
          this.searchAutoComplete.classList.add('hidden');
        }.bind(this),500);
      }
    }
  
    Glosar.prototype.matchQuery = function(q){
      var firstLetter = q.slice(0,1);
      var articles = cache.articles;
      var match_articles = [];
      
      if(articles){
        match_articles = articles.filter(function(art, index){
          var title = art.title.toLowerCase();
          return title.indexOf(q) > -1
        });
      }
  
      return match_articles;
    }
    
    Glosar.prototype.autoComplete = function(q){
      if(!q) return;
  
      var q_arr = q.split(' ');
      var match_articles = [];
  
      this.searchResultUrl = cache.searchResultUrl + '?handle='+ cache.handle +'&q=' + q_arr.join('+');
  
      if(q_arr.length > 1){
        var matched_q_arr = [];
        q_arr.map(function(q_val, index){
          if(q_val){
            var temp = this.matchQuery(q_val.trim());
            if(temp.length){
              var temp_arr = [];
              for(var i = 0; i < 2; i++) temp_arr.push(temp[i]);
              matched_q_arr = matched_q_arr.concat(temp_arr);
            }
          }
        }.bind(this));
  
        match_articles = matched_q_arr;
      } else {
        match_articles = this.matchQuery(q.trim());
      }
      if(match_articles.length){
        match_articles = theme.Helpers.uniqueArrOfObj(match_articles);
      }
  
      if(cache.isGlosarSearchPage){
        var ul = this.buildSearchList(match_articles);
        this.result_wrapper.innerHTML = ul.innerHTML;
      }
      if(cache.isGlosarPage){
        this.buildSearchHtml(match_articles);
      }
    }
  
    Glosar.prototype.buildSearchList = function(articles){
      var ul = document.createElement('ul');
      
      articles.forEach(function(item, index){
        if(!item) {
          return false;
        }
  
        var li = document.createElement('li');
        var a = document.createElement('a');
        li.className = 'p-3';
        if(cache.isGlosarSearchPage){
          li.className += ' w-1/4';
        }
        a.className = 'text-black text-sm hover:underline';
        a.href = '/blogs/' + cache.handle + '/' + item.handle;
        a.innerHTML = item.title;
  
        li.appendChild(a);
        ul.appendChild(li);
      });
  
      return ul;
    }
    
    Glosar.prototype.buildSearchHtml = function(articles){
      if(articles.length > cache.LIMIT){
        var temp_arr = [];
        for(var i = 0; i < cache.LIMIT; i++) temp_arr.push(articles[i]);
        articles = temp_arr;
      }
  
      var newAutoComplete = document.createElement('div');
      var main_cta = document.createElement('a');
      main_cta.innerHTML = "Vezi toate rezultatele";
      main_cta.className = 'block mt-4 w-full h-10 bg-green text-white outline-none flex justify-center items-center rounded-b';
  
      if(articles.length){
        var ul = this.buildSearchList(articles);
        main_cta.href = this.searchResultUrl;
        newAutoComplete.appendChild(ul);
      } else {
        var q = this.searchInput.value.toLowerCase();
        if(q){
          main_cta.href = cache.blogUrl + '/tagged/' + q.slice(0,1);
        }
      }
      newAutoComplete.appendChild(main_cta);
      this.searchAutoComplete.innerHTML = newAutoComplete.innerHTML;
    }
  
    return Glosar;
})();

// Login Page
theme.Login = (function(){
    var selectors = {
      loginEmail:'#CustomerEmail',
      loginPswd: '[data-input-group-pswd]',
      btnSubmit:'[data-form-submit-btn]',
      btnValidateEmail: '[data-email-validate-btn]',
      inputGroup:'[data-input-group]',
      jsErrorIcon:'[data-js-error-icon]',
      jsSuccessIcon:'[data-js-success-icon]',
      errorMsg: '[data-js-error-msg]',
      s_str: '[name="x-shopify_sstr"]',
      timestamp: '[name="x-shopify_time"]',
      resWrapper: '[data-res-wrapper]',
      dataFormAction: '[data-form-action]',
      resendMail:'[data-resend-btn]',
      guestLoginCTA: '[data-guest-login-cta]'
    };
  
    var emailConfig = {
      id: "#CustomerEmail",
      name: "customer[email]",
      optional: false,
      regex: /\S+@\S+\.\S+/,
      depend: null,
      error: {
          empty: "Acest camp este obligatoriu",
          condition: "Campul e-mail nu este corect"
      }
    };
    
    var cache = {
      login_api_url: apiBaseUrl + '/api/customer/login',
      resend_api_url:  apiBaseUrl + '/api/customer/resend',
      resend_success_msg: 'Am trimis un mail de activare cont. Pentru a continua acceseaza link-ul din mail.'
    };
  
    function Login(container){    
      this.container = container;
      this.eventHandlers = {};
  
      this.init();
    }
  
    Login.prototype.init = function(){
      var recoverpswd_email_config = Object.assign({}, emailConfig, {
        id:"#RecoverEmail",
        name:'email'
      });
  
      this.eventHandlers.postEmail = this.postEmail.bind(this);
      this.eventHandlers.sendInvite = this.sendInvite.bind(this);
      this.eventHandlers.submitForm = this.submitForm.bind(this);
      this.eventHandlers.guestLogin = this.guestLogin.bind(this);
      
      this.emailInput = this.container.querySelector(selectors.loginEmail);
      this.pswdInput = this.container.querySelector(selectors.loginPswd);
      this.btnValidateEmail = this.container.querySelector(selectors.btnValidateEmail);
      this.btnResendMail = this.container.querySelector(selectors.resendMail);
      this.btnSubmit = this.container.querySelector(selectors.btnSubmit);
      this.guestLoginCTA = this.container.querySelector(selectors.guestLoginCTA);
      
      var login_fields = [
        emailConfig,
        {
          id: "#CustomerPassword",
          name: "customer[password]",
          optional: false,
          regex: null,
          depend: null,
          error: {
              empty: "Acest camp este obligatoriu",
              condition: "Acest camp este obligatoriu"
          }
        }
      ];
      // [emailConfig]
      this.formObj = new theme.InitForm('.account-auth-login',login_fields, true);
      new theme.InitForm('#RecoverPasswordForm',[recoverpswd_email_config]);
  
      // Validate Email CTA
      this.btnValidateEmail.addEventListener('click', this.eventHandlers.postEmail);
  
      // Resend Invite Mail
      this.btnResendMail.addEventListener('click', this.eventHandlers.sendInvite);
  
      // Submit Form Event
      this.btnSubmit.addEventListener('click', this.eventHandlers.submitForm);

      // Guest Login CTA
      if(this.guestLoginCTA) this.guestLoginCTA.addEventListener('click', this.eventHandlers.guestLogin);
    }
  
    Login.prototype.showHideCTA = function(cta_name){
      var Elem = this.btnValidateEmail;
  
      this.container.querySelectorAll('[data-action-cta]').forEach(function(cta){
        cta.classList.add('hide');
      });
  
      switch(cta_name){
        case 'resend': 

          Elem = this.btnResendMail;
          break;
  
        case 'submit': 
          Elem = this.btnSubmit;
          break;
  
        default: 
          Elem = this.btnValidateEmail;
      }
      Elem.classList.remove('hide');
    }
  
    Login.prototype.showLoading = function(show, cta_name){
      var elem = this.btnValidateEmail;
  
      switch(cta_name){
        case 'submit': 
          elem = this.btnSubmit; 
          break;
  
        case 'resend': 
          elem = this.btnResendMail;
          break;
        
        case 'guest':
          elem = this.guestLoginCTA;
          break;
  
        default: elem = this.btnValidateEmail;
      }

      try{
        if(show){
          elem.querySelector('[data-text]').classList.add('hide');
          elem.querySelector('[data-loader]').classList.remove('hide');
          elem.disabled = true;
        } else {
          elem.querySelector('[data-text]').classList.remove('hide');
          elem.querySelector('[data-loader]').classList.add('hide');
          elem.disabled = false;
        }
      } catch(err){
        // console.log(err);
      }
    }
  
    Login.prototype.showHideResponse = function(show, msg, success){
      var resWrapper = this.container.querySelector(selectors.resWrapper);
      if(msg) resWrapper.innerHTML = msg;
      if(success){
        resWrapper.classList.remove('bg-red-light');
        resWrapper.classList.add('bg-blue-light');
      } else {
        resWrapper.classList.add('bg-red-light');
        resWrapper.classList.remove('bg-blue-light');
      }
  
      if(show) resWrapper.classList.remove('hidden'); 
      else resWrapper.classList.add('hidden'); 
    }

    Login.prototype.displayResendMessage = function(msg){
      var resWrapper = this.container.querySelector(selectors.resWrapper);
      var dataFormAction = this.container.querySelector(selectors.dataFormAction);
      var inputGroup = this.container.querySelector(selectors.inputGroup);
      resWrapper.innerHTML = msg;
      resWrapper.classList.remove('hidden'); 
      resWrapper.classList.remove('bg-red-lightest');
      resWrapper.classList.remove('bg-red-light');
      resWrapper.classList.remove('text-red-intense');
      
      dataFormAction.classList.add('hide'); 
      inputGroup.classList.add('hide');

    }
  
    Login.prototype.validateEmail = function(){
      this.showHideResponse(0,'');
  
      var email = this.emailInput.value.trim();
      var inputGroup = this.emailInput.closest(selectors.inputGroup);
      var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
      var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
      var errMsg = inputGroup.querySelector(selectors.errorMsg);
      var isValid = theme.Helpers.validateWithRegex(email, emailConfig.regex);
  
      if(!isValid){
        this.emailInput.classList.add('input--error');
        if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
        if(errMsg){
          errMsg.innerHTML = emailConfig.error.condition;
          if(email.length === 0) errMsg.innerHTML = emailConfig.error.empty;
          errMsg.classList.remove('hidden');
        }
      } else {
        this.emailInput.classList.remove('input--error');
        if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
        if(errMsg) errMsg.innerHTML = '';
      }
  
      return isValid;
    }
  
    Login.prototype.postEmail = function(evt){
      var isEmailValid = this.validateEmail();
      if(isEmailValid){
        this.showLoading(1);
        var self = this;
        var email = this.emailInput.value.trim();
        var s_str = this.container.querySelector(selectors.s_str).value;
        var timestamp = this.container.querySelector(selectors.timestamp).value;
    
        var data = {
          "timestamp":timestamp,
          "email": email
        };
    
        var meta = {
          method: 'POST',
          headers: {
            "X-Shopify-Shop-Domain": Shopify.shop,
            "X-Shopify-Hmac-Sha256": s_str,
            "Accept": "application/json",
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        };
    
        fetch(cache.login_api_url, meta).then(function(res){
          if(res.ok) return res;
          else return res.json();
        }).then(function(json){
          self.handleEmailResponse(json);
          self.showLoading(0);
        }).catch(function(err){
          // console.log('err', err);
          self.showLoading(0);
        });
      }
    }
  
    Login.prototype.sendInvite = function(){
      var isEmailValid = this.validateEmail();
      if(isEmailValid){
        this.showLoading(1, 'resend');
        var self = this;
        var email = this.emailInput.value.trim();
        var s_str = this.container.querySelector(selectors.s_str).value;
        var timestamp = this.container.querySelector(selectors.timestamp).value;
    
        var data = {
          "email": email,
          "timestamp": timestamp
        };
    
        var meta = {
          method: 'POST',
          headers: {
            "X-Shopify-Shop-Domain": Shopify.shop,
            "X-Shopify-Hmac-Sha256": s_str,
            "Accept": "application/json",
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        };
    
        fetch(cache.resend_api_url, meta).then(function(res){
          if(res.ok) return res;
          else return res.json();
        }).then(function(json){
          self.handleResendResponse(json);
          self.showLoading(0, 'resend');
        }).catch(function(err){
          // console.log('err', err);
          self.showLoading(0, 'resend');
        });
      }
    }
  
    Login.prototype.handleEmailResponse = function(json){
      this.displayError(json);
  
      if(json.statusCode === 2101){
        this.showHideCTA('resend');
      } else {
        if(json.ok){
          this.showLoading(0);
          // Show Password Field
          this.pswdInput.classList.remove('hidden');
          // Show Submit CTA and Bind event
          this.showHideCTA('submit');
        }
      }
    }
  
    Login.prototype.handleResendResponse = function(json){
      this.displayError(json);
  
      if(json.ok){
        this.displayResendMessage(cache.resend_success_msg);
        //this.showLoading(0, 'resend');
      }
    }
  
    Login.prototype.displayError = function(json){
      var message = json.message;
  
      if(json.error || json.status === 400){
        var tempDiv = document.createElement('div');
        if(Array.isArray(message)){
          message.map(function(msg){
            var div = document.createElement('div');
            div.textContent = msg;
            tempDiv.appendChild(div);
          });
        } else {
          if(typeof message === 'string'){
            var div = document.createElement('div');
            div.textContent = message;
            tempDiv.appendChild(div);
          }
        }
  
        this.showHideResponse(1, tempDiv.innerHTML);
      }
    }
  
    Login.prototype.resetForm = function(){
      this.formObj.form.reset();
      this.showHideCTA();
      this.pswdInput.classList.add('hidden');
      var inputGroups = this.container.querySelectorAll(selectors.inputGroup);
      inputGroups.forEach(function(inputGroup){
        inputGroup.querySelectorAll('.input--error').forEach(function(input){
          input.classList.remove('input--error');
        });
        var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
        var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
        if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
      });
    }

    Login.prototype.guestLogin = function(evt){
      evt.preventDefault();

      this.showLoading(1, 'guest');
      var form = evt.target.closest('form');
      var checkout_url = theme.Helpers.getParamFromURL('checkout_url');

      theme.submitFormViaAjax({
        form: form,
        type: "post",
        successCB: function(res){
          window.location.href = checkout_url || '/checkout';
        },
        errorCB: function(err){
          form.submit();
        }
      });
    }

    Login.prototype.submitForm = function(evt){
      evt.preventDefault();
      var res = this.formObj._validateForm();
      var isFormValid = res.status;
      
      if(isFormValid){
        this.showLoading(1, 'submit');
        this.formObj.form.submit();
      } else {
        console.error('Invalid Form');
      }
    }
  
    // Login.prototype.submitForm = function(evt){
    //   evt.preventDefault();
    //   var res = this.formObj._validateForm();
    //   var form = this.formObj.form;
      
    //   if(res.status){
    //     this.showLoading(1, 'submit');
    //     var checkout_url = theme.Helpers.getParamFromURL('checkout_url');
    //     var return_url = theme.Helpers.getParamFromURL('return_url');

    //     theme.submitFormViaAjax({
    //       form: form,
    //       type: "post",
    //       successCB: function(res){
    //         window.location.href = checkout_url || return_url || '/account';
    //       },
    //       errorCB: function(err){
    //         form.submit();
    //       }
    //     });
    //   } else {
    //     // console.error('Invalid Form');
    //   }
    // }
  
    return Login;
})();



// Register Page - Light Version - T&C
theme.RegisterLight = (function(){
  var selectors = {
    registrationForm:'[data-registration-form]',
    btnSubmit:'[data-form-submit-btn]',
    inputGroup:'[data-input-group]',
    jsErrorIcon:'[data-js-error-icon]',
    jsSuccessIcon:'[data-js-success-icon]',
    errorMsg: '[data-js-error-msg]',
    optionalRequired: '[data-optional-required]',
  };

  var regex = {
    card: /(?=.{13,})/
  };

  var errorMsg = {
    card:'Codul cardului de fidelitate introdus trebuie sa contina 13 cifre',
    dob:'Varsta minima 18 ani',
    empty:'Acest camp este obligatoriu'
  };

  var successMsg = {
    default:'Contul tau a fost creat cu succes. Ai primit un email pentru activarea contului. Urmareste instructiunile din email pentru activarea contului tau. Cumparaturi placute!'
  };

  function RegisterLight(container){
    this.container = container;
    this.eventHandlers = {};

    if(container.dataset.successMsg){
      successMsg.default = container.dataset.successMsg;
    }

    this.init();
  }

  RegisterLight.prototype.init = function(){
    var self = this;
    var fields=[{
      id:"#RegisterForm-FirstName",
      name:"customer[first_name]",
      optional:!1,regex:/(?=.{3,})/,
      depend:null,
      error:{
        empty:"Acest camp este obligatoriu",
        condition:"Numele trebuie sa contina minim 3 caractere"
      }
    },
      {
        id:"#RegisterForm-LastName",
        name:"customer[last_name]",
        optional:!1,
        regex:/(?=.{1,})/,
        depend:null,
        error:{
          empty:"Acest camp este obligatoriu",
          condition:"Numele trebuie sa contina minim 1 caractere"
        }
      },
        {
          id:"#RegisterForm-email",
          name:"customer[email]",
          optional:!1,
          regex:/\S+@\S+\.\S+/,
          depend:null,
          error:{
            empty:"Acest camp este obligatoriu",
            condition:"Campul e-mail nu este corect"
          }
        },
        {
          id: "#RegisterCustomerPassword",
          name: "customer[password]",
          optional: false,
          regex: null,
          depend: null,
          error: {
              empty: "Acest camp este obligatoriu",
              condition: "Acest camp este obligatoriu"
          }
        },
          // {
          //   id:"#RegisterForm-phone",
          //   name:"customer[note][phone]",
          //   optional:!1,
          //   regex:/^0[1-9]{1}[0-9]{8}$/,
          //   depend:null,
          //   error:{
          //     empty:"Acest camp este obligatoriu",
          //     condition:"Numarul de telefon nu este corect. Introdu 10 cifre, incepand cu 0"
          //   }
          // },
            {
              id:"#terms_consent",
              name:"customer[note][T&C_true]",
              optional:!1,
              regex:null,
              depend:null,
              error:{
                empty:"Acest camp este obligatoriu"
              }
            }
          ];
    this.formObj = new theme.InitForm('.account-auth-registration',fields, true);

    this.btnSubmit = this.container.querySelector(selectors.btnSubmit);

    // Submit Form
    this.btnSubmit.addEventListener('click', this.submitForm.bind(this));
  }


  RegisterLight.prototype.showLoading = function(show){
    if(show){
      this.btnSubmit.querySelector('[data-text]').classList.add('hide');
      this.btnSubmit.querySelector('[data-loader]').classList.remove('hide');
      this.btnSubmit.disabled = true;
    } else {
      this.btnSubmit.querySelector('[data-text]').classList.remove('hide');
      this.btnSubmit.querySelector('[data-loader]').classList.add('hide');
      this.btnSubmit.disabled = false;
    }
  }

  RegisterLight.prototype.resetForm = function(){
    this.formObj.form.reset();
    var inputGroups = this.container.querySelectorAll(selectors.inputGroup);

    inputGroups.forEach(function(inputGroup){
      inputGroup.querySelectorAll('.input--error').forEach(function(input){
        input.classList.remove('input--error');
      });
      var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
      var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
      if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
      if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
    });
  }

  RegisterLight.prototype.submitForm = function(evt){      
    evt.preventDefault();

    var resWrapper = this.container.querySelector('[data-res-wrapper]');
    resWrapper.innerHTML = '';
    resWrapper.classList.add('hidden');
    
    var isValid = true;
    var res = this.formObj._validateForm();
    
    if(!res.status){
      isValid = false;
    }
    
    if(isValid){
      this.showLoading(1);    
      this.container.querySelector(selectors.registrationForm).submit();
    } else {
      // console.error('Invalid Form');
    }
  }

  return RegisterLight;
})();



  
// Register Page - Fidelity card option
theme.Register = (function(){
    var selectors = {
      card: '#RegisterForm-cod_card',
      gender: '[name="customer[note][Sex]"]',
      activeGender: '[name="customer[note][Sex]"]:checked',
      numOfChildren: '[name="customer[note][Children]"]',
      DOB: '[name="customer[note][DOB]"]',
      btnSubmit:'[data-form-submit-btn]',
      optionalRadio: '[data-radio]',
      activeOptionalRadio: '[data-radio]:checked',
      inputGroup:'[data-input-group]',
      jsErrorIcon:'[data-js-error-icon]',
      jsSuccessIcon:'[data-js-success-icon]',
      errorMsg: '[data-js-error-msg]',
      optionalRequired: '[data-optional-required]',
      issueCardWrapper: '[data-new-card]',
      existCardWrapper: '[data-card-fidelity]'
    };
  
    var regex = {
      card: /(?=.{13,})/
    };
  
    var errorMsg = {
      card:'Codul cardului de fidelitate introdus trebuie sa contina 13 cifre',
      dob:'Varsta minima 18 ani',
      empty:'Acest camp este obligatoriu'
    };
  
    var successMsg = {
      default:'Contul tau a fost creat cu succes. Ai primit un email pentru activarea contului. Urmareste instructiunile din email pentru activarea contului tau. Cumparaturi placute!'
    };
  
    var cache = {
      register_api_url: apiBaseUrl + '/api/customer/register',
      activeSection: null
    };
  
    function Register(container){
      this.container = container;
      this.eventHandlers = {};

      if(container.dataset.successMsg){
        successMsg.default = container.dataset.successMsg;
      }

      this.init();
    }
  
    Register.prototype.init = function(){
      var self = this;
      var fields=[{id:"#RegisterForm-FirstName",name:"customer[first_name]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 3 caractere"}},{id:"#RegisterForm-LastName",name:"customer[last_name]",optional:!1,regex:/(?=.{1,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 1 caractere"}},{id:"#RegisterForm-email",name:"customer[email]",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Campul e-mail nu este corect"}},{id:"#RegisterForm-phone",name:"customer[note][phone]",optional:!1,regex:/^0[1-9]{1}[0-9]{8}$/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numarul de telefon nu este corect. Introdu 10 cifre, incepand cu 0"}},{id:"#terms_consent",name:"customer[note][T&C_true]",optional:!1,regex:null,depend:null,error:{empty:"Acest camp este obligatoriu"}}];
      this.formObj = new theme.InitForm('.account-auth-registration',fields, true);
  
      this.btnSubmit = this.container.querySelector(selectors.btnSubmit);
  
      // Optional Radio Toggle :: At a time, anyone will be open
      var optionalRadioElems = this.container.querySelectorAll(selectors.optionalRadio);
      optionalRadioElems.forEach(function(elem,index){
        elem.addEventListener('input', this.toggleRadioElem.bind(this));
      }, this);

      var sex_selector = this.container.querySelectorAll(selectors.gender);
      sex_selector.forEach(function(input){
        input.addEventListener('input', function(){
          self.newCardValidateField('sex');
        });
      });

      var dob_selector = this.container.querySelector(selectors.DOB);
      dob_selector.addEventListener('input', function(evt){
        var value = this.value;
        if(evt.inputType !== 'deleteContentBackward'){
          if(value.length === 2) this.value = value + '/';
          if(value.length === 5) this.value = value + '/';
          if(value.length > 10) this.value = value.slice(0,10);
        }
         
        self.newCardValidateField('dob');
      });

      var card_selector = this.container.querySelector(selectors.card);
      card_selector.addEventListener('input', function(){
        self.existCardValidateField();
      });
  
      // Submit Form
      this.btnSubmit.addEventListener('click', this.submitForm.bind(this));
    }
  
    Register.prototype.toggleRadioElem = function(evt){
      var optionalRadioElems = this.container.querySelectorAll(selectors.optionalRadio);
      optionalRadioElems.forEach(function(elem){
        var inputs = elem.parentElement.querySelectorAll('.form-checkbox-body input');
        var selects = elem.parentElement.querySelectorAll('.form-checkbox-body select');
        if(elem === evt.target){
          if(elem.checked){
            propChange(inputs, 'disabled', false);
            propChange(selects, 'disabled', false);
            cache.activeSection = evt.target.name;
          } else {
            propChange(inputs, 'disabled', true);
            propChange(selects, 'disabled', true);
            cache.activeSection = null;  
          }
        } else {
          elem.checked = false;
          propChange(inputs, 'disabled', true);
          propChange(selects, 'disabled', true);
        }
      });
  
      function propChange(elems, prop, propVal){
        if(elems.length){
          elems.forEach(function(elem){
            elem[prop] = propVal;
            if(propVal)elem.classList.remove('input--error');
          });
  
          if(propVal){
            var inputGroup = elems[0].closest('[data-input-group]');
            var jsErrorIcon = inputGroup.querySelectorAll('[data-js-error-icon]');
            var jsSuccessIcon = inputGroup.querySelectorAll('[data-js-success-icon]');
            var errorMsg = inputGroup.querySelectorAll('[data-js-error-msg]');
            
            if(jsErrorIcon) {
              jsErrorIcon.forEach(function(item){
                item.classList.add('hidden');
              });
            }
  
            if(jsSuccessIcon) {
              jsSuccessIcon.forEach(function(item){
                item.classList.add('hidden');
              });
            }
  
            if(errorMsg){
              errorMsg.forEach(function(item){
                item.innerHTML = '';
                item.classList.add('hidden');
              });
            }
          }
        }
      }
    }

    Register.prototype.newCardValidateField = function(field){
      var isValid = true;
      var inputGroup = this.container.querySelector(selectors.issueCardWrapper);
  
      if(field === 'dob'){
        var dobElem = inputGroup.querySelector(selectors.DOB);
        var dob_errMsg = inputGroup.querySelector('[data-dob] [data-js-error-msg]');
        var jsErrorIcon = inputGroup.querySelector('[data-dob] [data-js-error-icon]');
        var jsSuccessIcon = inputGroup.querySelector('[data-dob] [data-js-success-icon]');
        var inputVal = dobElem.value.trim();
        var res = theme.Helpers.validateAge(inputVal);
        var is_dob_valid = res.status;
        if(!is_dob_valid) dob_errMsg.innerHTML = res.message;
        
        if(inputVal.length === 0){
          dob_errMsg.innerHTML = errorMsg.empty;
          is_dob_valid = false;
        }
  
        if(is_dob_valid){
          dobElem.classList.remove('input--error');
          dob_errMsg.classList.add('hidden');
          if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
          if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
        } else {
          dobElem.classList.add('input--error');
          dob_errMsg.classList.remove('hidden');
          if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
          if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
        }
  
        isValid = is_dob_valid;
      }
  
      if(field === 'sex'){
        var sex = inputGroup.querySelector(selectors.activeGender);
        var sex_errMsg = inputGroup.querySelector('[data-sex] [data-js-error-msg]');
        if(!sex){
          sex_errMsg.innerHTML = errorMsg.empty;
          sex_errMsg.classList.remove('hidden');
          isValid = false;
        } else {
          sex_errMsg.innerHTML = '';
          sex_errMsg.classList.add('hidden');
        }
      }
  
      return isValid;
    }

    Register.prototype.existCardValidateField = function(field){
      var isValid = true;
      var inputGroup = this.container.querySelector(selectors.existCardWrapper);
      var cardElem = inputGroup.querySelector(selectors.card);
      var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
      var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
      var errMsg = inputGroup.querySelector(selectors.errorMsg);
    
      var inputVal = cardElem.value.trim();
      isValid = theme.Helpers.validateWithRegex(inputVal, regex.card);
      if(!isValid) errMsg.innerHTML = errorMsg.card;
  
      if(inputVal.length === 0){
        errMsg.innerHTML = errorMsg.empty;
        isValid = false;
      }
  
      if(isValid){
        cardElem.classList.remove('input--error');
        if(errMsg) {
          errMsg.innerHTML = '';
          errMsg.classList.add('hidden');
        }
        if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
      } else {
        cardElem.classList.add('input--error');
        if(errMsg) errMsg.classList.remove('hidden');
        if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
      }
  
      return isValid;
    }
  
    Register.prototype.preparePostData = function(res){
      if(!res) return {};
  
      var data = {"firstName":'',"lastName":'',"email": "", "phone": "","acceptsMarketing": false,"timestamp":''};
      data.timestamp = this.container.querySelector('[name="x-shopify_time"]').value;
      data.acceptsMarketing = this.container.querySelector('#gdpr_consent').checked ? 1 : 0;
  
      res.data.forEach(function(obj){
        var name = obj.field.name;
        var value = obj.field.value;
        if(name.indexOf('first_name') > -1){
          data.firstName = value
        }
        if(name.indexOf('last_name') > -1){
          data.lastName = value
        }
        if(name.indexOf('email') > -1){
          data.email = value
        }
        if(name.indexOf('phone') > -1){
          data.phone = value
        }
      });
  
      var activeElem = this.container.querySelector(selectors.activeOptionalRadio);
      if(activeElem){
        var inputGroup = activeElem.closest(selectors.inputGroup);
        if(activeElem.name.indexOf('CARD_') > -1){
          data.fidelityCardNo = inputGroup.querySelector('.form-checkbox-body #RegisterForm-cod_card').value;
        }
        if(activeElem.name.indexOf('Enroll Loyalty Program') > -1){
          data.wantsCard = 1;
          data.noKids = inputGroup.querySelector('#num_children').value;
          data.sex = inputGroup.querySelector('.form-checkbox-body .input--subgroup input:checked').value;
          data.birthday = inputGroup.querySelector('.form-checkbox-body #RegisterForm-dob').value.trim();
          // data.birthday = bday.split('-').reverse().join('/');
        }
      }
  
      return data;
    }
  
    Register.prototype.postData = function(res){
      if(res.status){
        var self = this;
        var ss = this.container.querySelector('[name="x-shopify_sstr"]').value;
        var data = this.preparePostData(res);
        var meta = {
          method: 'POST',
          headers: {
            "X-Shopify-Shop-Domain": Shopify.shop,
            "X-Shopify-Hmac-Sha256": ss,
            "Accept": "application/json",
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        };
  
        fetch(cache.register_api_url, meta).then(function(res){
          if(res.ok){
            return res;
          } else {
            return res.json();
          }
        }).then(function(json){
          self.displayResponse(json);
          self.showLoading(0);
        }).catch(function(err){
          // console.log('err', err);
          self.showLoading(0);
        });
      }
    }
  
    Register.prototype.displayResponse = function(json){
      var self = this;
      var resWrapper = this.container.querySelector('[data-res-wrapper]');
      var res_msg = '';
      resWrapper.classList.remove('hidden');
  
      if(json.ok){
        resWrapper.classList.remove('bg-red-light');
        resWrapper.classList.add('bg-blue-light');
        res_msg = successMsg.default;
        this.resetForm();
      } else {
        var message = json.message;
        if(message){
          var tempDiv = document.createElement('div');
          if(Array.isArray(message)){
            message.map(function(msg){
              checkErrorType(msg);
              var div = document.createElement('div');
              div.textContent = msg;
              tempDiv.appendChild(div);
            });
          } else {
            if(typeof message === 'string'){
              checkErrorType(message);
              var div = document.createElement('div');
              div.textContent = message;
              tempDiv.appendChild(div);
            }
          }
        }
        resWrapper.classList.add('bg-red-light');
        resWrapper.classList.remove('bg-blue-light');
        res_msg = tempDiv.innerHTML;
      }
      resWrapper.innerHTML = res_msg;
  
      function checkErrorType(msg){
        var input_elem = null;
        msg = msg.toLowerCase();
        if(msg.indexOf('email') > -1){
          input_elem = self.container.querySelector('#RegisterForm-email');
        }
        if(msg.indexOf('telefon') > -1 || msg.indexOf('phone') > -1){
          input_elem = self.container.querySelector('#RegisterForm-phone');
        }
        if(msg.indexOf('card') > -1){
          input_elem = self.container.querySelector('#RegisterForm-cod_card');
        }
  
        if(input_elem){
          input_elem.classList.add('input--error');
          var inputGroup = input_elem.closest(selectors.inputGroup);
          if(inputGroup){
            var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
            var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
            if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
            if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
          }
        }
      }
    }
  
    Register.prototype.showLoading = function(show){
      if(show){
        this.btnSubmit.querySelector('[data-text]').classList.add('hide');
        this.btnSubmit.querySelector('[data-loader]').classList.remove('hide');
        this.btnSubmit.disabled = true;
      } else {
        this.btnSubmit.querySelector('[data-text]').classList.remove('hide');
        this.btnSubmit.querySelector('[data-loader]').classList.add('hide');
        this.btnSubmit.disabled = false;
      }
    }
  
    Register.prototype.resetForm = function(){
      this.formObj.form.reset();
      var inputGroups = this.container.querySelectorAll(selectors.inputGroup);
      var radioElems = this.container.querySelectorAll('[data-radio]');
      radioElems.forEach(function(input){
        input.checked = false;
      });
      inputGroups.forEach(function(inputGroup){
        inputGroup.querySelectorAll('.input--error').forEach(function(input){
          input.classList.remove('input--error');
        });
        var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
        var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
        if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
      });
    }
  
    Register.prototype.submitForm = function(evt){
      evt.preventDefault();
      var resWrapper = this.container.querySelector('[data-res-wrapper]');
      resWrapper.innerHTML = '';
      resWrapper.classList.add('hidden');
      
      var isValid = true;
      var isAdditionalFieldValid = true;
      switch(cache.activeSection){
        case 'customer[note][CARD_]': 
          isAdditionalFieldValid = this.existCardValidateField();
          break;
        case 'customer[note][Enroll Loyalty Program]':
          var dob_status = this.newCardValidateField('dob');
          var sex_status = this.newCardValidateField('sex');
          if(!dob_status || !sex_status) isAdditionalFieldValid = false;
          break;
        default:
          isAdditionalFieldValid = true;
      }

      var res = this.formObj._validateForm();
      if(!isAdditionalFieldValid || !res.status){
        isValid = false;
      }
      
      if(isValid){
        this.showLoading(1);
        this.postData(res);
      } else {
        // console.error('Invalid Form');
      }
    }
  
    return Register;
})();
  
// Blog Article Page
theme.Article = (function(){
    var selectors = {
      comment_form:'form.comment-form',
      comment_form_wrapper:'.article-comment-form',
      articleList: '#articleList',
      prev_next_article: '[data-prev-next-article]',
      prev_next_article_list: '[data-prev-next-article-list]'
    };
  
    function Article(container){
      if(!container){
        throw new Error('Invalid Container');
        return;
      }
      
      this.container = container;
      this.articleURL = '/blogs/' + this.container.dataset.articleHandle;
      this.init();
    }
  
    Article.prototype.init = function(){
      var fields=[{id:"#CommentForm-author",name:"comment[author]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Numele trebuie sa contina minim 3 caractere"}},{id:"#CommentForm-email",name:"comment[email]",optional:!1,regex:/\S+@\S+\.\S+/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Campul e-mail nu este corect"}},{id:"#CommentForm-body",name:"comment[body]",optional:!1,regex:/(?=.{3,})/,depend:null,error:{empty:"Acest camp este obligatoriu",condition:"Mesaj trebuie sa contina minim 3 caractere"}}];
      new theme.InitForm(selectors.comment_form_wrapper, fields);
      var page = theme.Helpers.getParamFromURL('page');
      var comment = theme.Helpers.getParamFromURL('comment');
      if(page || comment){
        var element = this.container.querySelector(selectors.articleList);
        var margin = page ? 59 : -30;
        if(comment){
          element = this.container.querySelector(selectors.comment_form);
          history.replaceState('','', this.articleURL);
        }
        setTimeout(function(){
          var scrollPos = element.offsetTop + margin;
          window.scrollTo(0, scrollPos);
        },1500);
      }
  
      this.fetchPrevNextArticle();
    }
  
    Article.prototype.fetchPrevNextArticle = function(){
      var prev_next_article_list = this.container.querySelector(selectors.prev_next_article_list);
      if(prev_next_article_list.childElementCount > 0) return;
  
      var prev_next_article = selectors.prev_next_article;
      var self = this;
  
      fetch(this.articleURL).then(function(res){
        return res.text();
      }).then(function(htmlStr){
        var body = theme.Helpers.stringToHTML(htmlStr);
        var art_sections = self.container.querySelectorAll(prev_next_article);
        var new_art_sections = body.querySelectorAll(prev_next_article);
        art_sections.forEach(function(section, index){
          art_sections[index].innerHTML = new_art_sections[index].innerHTML;
        });
      }).catch(function(err){
        // console.log(err)
      });
    }
  
    return Article;
})();
  
// Blog Page
theme.Blog = (function(){
    var selectors = {
      all_article: '#art_all'
    };
  
    function Blog(container){
      this.container = container;
      this.init();
    }
  
    Blog.prototype.init = function(){
      var page = theme.Helpers.getParamFromURL('page');
      if(page){
        var element = this.container.querySelector(selectors.all_article);
        setTimeout(function(){
          var scrollPos = element.offsetTop;
          window.scrollTo(0, scrollPos);
        },1500);
      }
    }
  
    return Blog;
})();

// Fidelity Card
theme.FidelityCard = (function(){
  var selectors = {
    issueCardWrapper: '.col-left [data-input-group]',
    existCardWrapper: '[data-card-fidelity]',
    phoneWrapper: '.fidelity-phone-wrapper',
    phoneExistingWrapper: '.fidelity-phone-exist-wrapper',
    card: '#fidelity-cod_card',
    exist_phone:'.fidelity-phone-exist-wrapper [name="customer[note][Phone]"]',
    phone: '[name="customer[note][Phone]"]',
    gender: '[name="customer[note][Sex]"]',
    activeGender: '[name="customer[note][Sex]"]:checked',
    hasKids: '[name="customer[note][Children]"]',
    activeHasKids: '[name="customer[note][Children]"]:checked',
    DOB: '[name="customer[note][DOB]"]',
    county: '[name="customer[note][county]"]',
    countySearch: '#county-search',
    countyList: '#county-list',
    city: '[name="customer[note][city]"]',
    citySearch: '#city-search',
    cityList: '#city-list',
    openedListClass: 'js--opened-select',
    email: '[name="email"]',
    optionalRadio: '[data-radio]',
    activeOptionalRadio: '[data-radio]:checked',

    inputGroup:'[data-input-group]',
    jsErrorIcon:'[data-js-error-icon]',
    jsSuccessIcon:'[data-js-success-icon]',
    errorMsg: '[data-js-error-msg]',

    btnApplyForCard:'[data-apply-card-btn]',
    btnValidateCard:'[data-validate-card-btn]',

    loginModel: '[data-login-model]',
    loginModelClose: '[data-btn-cancel]',

    resWrapper: '[data-res-wrapper]',
    resSuccessWrapper: '[data-notify-text]'
  };
  
  var cache = {
    api: {
      validate_card: apiBaseUrl + '/api/customer/checkMembership',
      issue_new_card: apiBaseUrl+ '/api/customer/card',
      getCounties: apiBaseUrl+ '/api/geolocation/counties',
      getCities: apiBaseUrl+ '/api/geolocation/cities',
    },
    regex: {
      card: /(?=.{13,})/,
      phone: /^0[1-9]{1}[0-9]{8}$/,
    },
    errorMsg: {
      card:'Codul cardului de fidelitate introdus trebuie sa contina 13 cifre',
      phone: "Numarul de telefon invalid, numarul trebuie sa contina 10 cifre",
      dob:'Varsta minima 18 ani',
      empty:'Acest camp este obligatoriu'
    },
    successMsg: {
      default:'Succes'
    },
    activeSection: null
  };

  function FidelityCard(container){
    this.container = container;

    cache.timestamp = this.container.querySelector('[name="x-shopify_time"]').value;
    cache.ss = this.container.querySelector('[name="x-shopify_sstr"]').value;
    this.eventHandlers = {};
    this.init();
  }
  
  FidelityCard.prototype.init = function(){
    var self = this;
    this.loginModel = this.container.querySelector(selectors.loginModel);
    var optionalRadioElems = this.container.querySelectorAll(selectors.optionalRadio);

    if(this.loginModel){
      var loginModelClose = this.loginModel.querySelector(selectors.loginModelClose);
      loginModelClose.addEventListener('click', function(evt){
        self.toggleLoginModel(0);
      }, false);
    } else {
      this.btnApplyForCard = this.container.querySelector(selectors.btnApplyForCard);
      this.btnValidateCard = this.container.querySelector(selectors.btnValidateCard);

      this.eventHandlers.submitForm = this.submitForm.bind(this);

      var sex_selector = this.container.querySelectorAll(selectors.gender);
      sex_selector.forEach(function(input){
        input.addEventListener('input', function(){
          self.newCardValidateField('sex');
        });
      });

      var hasKidsSelector = this.container.querySelectorAll(selectors.hasKids);
      hasKidsSelector.forEach(function(input){
        input.addEventListener('input', function(){
          self.newCardValidateField('hasKids');
        });
      });

      var phone_selector = this.container.querySelector(selectors.phone);
      phone_selector.addEventListener('input', function(){
        self.validatePhoneValidateField();
      });

      var phone_selector_exist = this.container.querySelector(selectors.phoneExistingWrapper);
      phone_selector_exist.addEventListener('input', function(){
        self.validatePhoneValidateField('exist');
      });

      var dob_selector = this.container.querySelector(selectors.DOB);
      dob_selector.addEventListener('input', function(evt){
        var value = this.value;

        if(evt.inputType !== 'deleteContentBackward'){
          if(value.length === 2) this.value = value + '/';
          if(value.length === 5) this.value = value + '/';
          if(value.length > 10) this.value = value.slice(0,10);
        } 
        self.newCardValidateField('dob');
      });

      /**
       * Cities and counties
       * ${location} - {('county', 'city')}
       * ${location} - Hidden input that stores the string value, not ID. The endpoint needs string
       * ${location}Search - Input responsible for the search. It displays the selected location, 
       *        but the search value remains the one that was typed 
       * ${location}List - Parent div that holds the list of locations
       */
      self.getCounties();
      const countySearch = this.container.querySelector(selectors.countySearch);
      const city = this.container.querySelector(selectors.city);
      const citySearch = this.container.querySelector(selectors.citySearch);

      countySearch.addEventListener('input', function () {
        self.searchLocation('county');
        self.newCardValidateField('county');

        /*Remove city list and clear city ID and value*/
        self.updateLocationsList([], 'city');
        citySearch.value = '';
        city.value = citySearch.value;
      });

      countySearch.addEventListener('focus', function () {
        self.toggleLocationSearch('city', false)
        self.toggleLocationSearch('county')
      });


      citySearch.addEventListener('input', function () {
        self.searchLocation('city');
        self.newCardValidateField('city');
      });

      citySearch.addEventListener('focus', function () {
        self.toggleLocationSearch('county', false)
        self.toggleLocationSearch('city')
      });

      document.addEventListener('click', function (event) {
        self.selectLocation(event.target);
      });

      document.addEventListener('keydown', function (event) {
        if (event.keyCode === 38) {
          self.highlightLocation('up');
        } else if (event.keyCode === 40) {
          self.highlightLocation('down');
        } else if (event.key === 'Enter') {
          self.selectHighlightedLocation();
        }
      });
      /*End of Cities and counties*/

      var card_selector = this.container.querySelector(selectors.card);
      card_selector.addEventListener('input', function(){
        self.existCardValidateField();
      });
    }
    
    // Optional Radio Toggle :: At a time, anyone can be open
    optionalRadioElems.forEach(function(elem,index){
      elem.addEventListener('input', this.toggleRadioElem.bind(this));
    }, this);
  }

  FidelityCard.prototype.highlightLocation = function (arrow) {
    const listParent = this.container.querySelector(`.${selectors.openedListClass}`);
    if (!listParent) return;

    const filteredLocations = listParent.querySelectorAll('div:not(.hidden)');
    if (filteredLocations.length === 0) return;

    const currentHighlight = listParent.querySelector('.js--highlight');
    if (!currentHighlight) {
      filteredLocations[0].classList.add('js--highlight', 'bg-blue-light', 'text-white');
    } else {
      let sibling;
      if (arrow === 'down') {
        sibling = currentHighlight.nextElementSibling;
        while (sibling) {
          if (!sibling.matches('.hidden')) {
            break
          }
          sibling = sibling.nextElementSibling
        }
      } else if (arrow === 'up') {
        sibling = currentHighlight.previousSibling;
        while (sibling) {
          if (!sibling.matches('.hidden')) {
            break
          }
          sibling = sibling.previousSibling
        }
      }

      if (!sibling) return

      this.removeHighlight();
      sibling.classList.add('js--highlight', 'bg-blue-light', 'text-white');
      sibling.scrollIntoView({behavior: 'instant', block: 'nearest', inline: 'start'})
    }
  }

  FidelityCard.prototype.selectHighlightedLocation = function() {
    const highlight = this.container.querySelector('.js--highlight');
    if (!highlight) return;

    this.selectLocation(highlight);
    highlight.classList.remove('js--highlight', 'bg-blue-light', 'text-white');
  }

  FidelityCard.prototype.selectLocation = function (element) {
    const county = this.container.querySelector(selectors.county);
    const countySearch = this.container.querySelector(selectors.countySearch);
    const city = this.container.querySelector(selectors.city);
    const citySearch = this.container.querySelector(selectors.citySearch);

    /*Close or open any dropdowns*/
    this.toggleLocationSearch('county', (element === countySearch))
    this.toggleLocationSearch('city', (element === citySearch))

    /*If valid, select a location*/
    if (element.hasAttribute('county-id')) {
      /*Add the selected county's name to the search input and the ID to the county input*/
      countySearch.value = element.getAttribute('county-name');
      county.value = countySearch.value;
      this.getCities(element.getAttribute('county-id'));
      this.newCardValidateField('county');

      /*Clear city ID and value*/
      citySearch.value = '';
      city.value = citySearch.value;
    }

    if (element.hasAttribute('city-id')) {
      citySearch.value = element.getAttribute('city-name');
      city.value = citySearch.value;
      this.newCardValidateField('city');
    }
  }

  FidelityCard.prototype.showLoading = function(show, target){
    var elem = this.btnApplyForCard;
    if(target === 'exist_card') elem = this.btnValidateCard;

    if(show){
      elem.querySelector('[data-text]').classList.add('hide');
      elem.querySelector('[data-loader]').classList.remove('hide');
      elem.disabled = true;
    } else {
      elem.querySelector('[data-text]').classList.remove('hide');
      elem.querySelector('[data-loader]').classList.add('hide');
      elem.disabled = false;
    }
  }

  FidelityCard.prototype.toggleLoginModel = function(show){
    if(this.loginModel){
      if(show) this.loginModel.classList.remove('hide');
      else this.loginModel.classList.add('hide');
    }
  }

  FidelityCard.prototype.toggleRadioElem = function(evt){
    var optionalRadioElems = this.container.querySelectorAll(selectors.optionalRadio);
    this.toggleLoginModel(1);
    if(this.loginModel){
      evt.target.checked = false;
      return;
    }

    this.showLoading(0, this.btnApplyForCard);
    this.showLoading(0, this.btnValidateCard);

    optionalRadioElems.forEach(function(elem){
      var inputs = elem.parentElement.querySelectorAll('.form-checkbox-body input');
      var selects = elem.parentElement.querySelectorAll('.form-checkbox-body select');
      if(elem === evt.target){
        if(elem.checked){
          propChange(inputs, 'disabled', false);
          propChange(selects, 'disabled', false);
          cache.activeSection = evt.target.name;
        } else {
          propChange(inputs, 'disabled', true);
          propChange(selects, 'disabled', true);  
          cache.activeSection = null;
        }
      } else {
        elem.checked = false;
        propChange(inputs, 'disabled', true);
        propChange(selects, 'disabled', true);
      }
    });

    function propChange(elems, prop, propVal){
      if(elems.length){
        elems.forEach(function(elem){
          elem[prop] = propVal;
          if(propVal) {
            if(elem.type && elem.type == 'text' && elem.type == 'date'){
              elem.value = '';
            }
            elem.classList.remove('input--error');
          }
        });

        if(propVal){
          var inputGroup = elems[0].closest('[data-input-group]');
          var jsErrorIcon = inputGroup.querySelectorAll('[data-js-error-icon]');
          var jsSuccessIcon = inputGroup.querySelectorAll('[data-js-success-icon]');
          var resWrapper = inputGroup.querySelectorAll('[data-res-wrapper]');
          var errorMsg = inputGroup.querySelectorAll('[data-js-error-msg]');
          
          if(jsErrorIcon) {
            jsErrorIcon.forEach(function(item){
              item.classList.add('hidden');
            });
          }

          if(jsSuccessIcon) {
            jsSuccessIcon.forEach(function(item){
              item.classList.add('hidden');
            });
          }

          if(resWrapper){
            resWrapper.forEach(function(item){
              item.innerHTML = '';
              item.classList.add('hidden');
            });
          }

          if(errorMsg){
            errorMsg.forEach(function(item){
              item.innerHTML = '';
              item.classList.add('hidden');
            });
          }
        }
      }
    }

    switch(cache.activeSection){
      case 'customer[note][CARD_]': 
          this.btnApplyForCard.removeEventListener('click', this.eventHandlers.submitForm, false);
          this.btnValidateCard.addEventListener('click', this.eventHandlers.submitForm, false);
          break;
      case 'customer[note][Enroll Loyalty Program]':
          this.btnApplyForCard.addEventListener('click', this.eventHandlers.submitForm, false);
          this.btnValidateCard.removeEventListener('click', this.eventHandlers.submitForm, false);
          break;
    }
  }

  FidelityCard.prototype.validatePhoneValidateField = function(type="new"){
    var isValid = true;

    var inputGroup = this.container.querySelector(selectors.phoneWrapper);
    if(type == 'exist') {
      inputGroup = this.container.querySelector(selectors.phoneExistingWrapper);
    }
    var phoneElem = inputGroup.querySelector(selectors.phone);
    var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
    var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
    var errMsg = inputGroup.querySelector(selectors.errorMsg);
    
    var inputVal = phoneElem.value.trim();
    isValid = theme.Helpers.validateWithRegex(inputVal, cache.regex.phone);
    if(!isValid) errMsg.innerHTML = cache.errorMsg.phone;

    if(inputVal.length === 0){
      errMsg.innerHTML = cache.errorMsg.empty;
      isValid = false;
    }
    
    if(isValid){
      phoneElem.classList.remove('input--error');
      if(errMsg) {
        errMsg.innerHTML = '';
        errMsg.classList.add('hidden');
      }
      if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
      if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
    } else {
      phoneElem.classList.add('input--error');
      if(errMsg) errMsg.classList.remove('hidden');
      if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
      if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
    }

    return isValid;
  }

  FidelityCard.prototype.newCardValidateField = function(field){
    var isValid = true;
    var inputGroup = this.container.querySelector(selectors.issueCardWrapper);

    if(field === 'dob'){
      var dobElem = inputGroup.querySelector(selectors.DOB);
      var dob_errMsg = inputGroup.querySelector('[data-dob] [data-js-error-msg]');
      var jsErrorIcon = inputGroup.querySelector('[data-dob] [data-js-error-icon]');
      var jsSuccessIcon = inputGroup.querySelector('[data-dob] [data-js-success-icon]');
      var inputVal = dobElem.value.trim();
      var res = theme.Helpers.validateAge(inputVal);
      var is_dob_valid = res.status;
      if(!is_dob_valid) dob_errMsg.innerHTML = res.message;
      
      if(inputVal.length === 0){
        dob_errMsg.innerHTML = cache.errorMsg.empty;
        is_dob_valid = false;
      }

      if(is_dob_valid){
        dobElem.classList.remove('input--error');
        dob_errMsg.classList.add('hidden');
        if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
      } else {
        dobElem.classList.add('input--error');
        dob_errMsg.classList.remove('hidden');
        if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
        if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
      }

      isValid = is_dob_valid;
    }

    if (field === 'county' || field === 'city') {
      let isValueValid = true;

      const inputName = `${field}Search`;
      const displayInput = this.container.querySelector(selectors[inputName]);
      const inputErrMsg = this.container.querySelector(`[data-${field}] [data-js-error-msg]`);
      const jsErrorIcon = this.container.querySelector(`[data-${field}] [data-js-error-icon]`);
      const jsSuccessIcon = this.container.querySelector(`[data-${field}] [data-js-success-icon]`);
      
      const inputVal = this.container.querySelector(selectors[field]).value.trim();
      if (inputVal.length === 0) {
        inputErrMsg.innerHTML = cache.errorMsg.empty;
        isValueValid = false;
      }

      displayInput.classList.toggle('input--error', !isValueValid);
      inputErrMsg.classList.toggle('hidden', isValueValid);
      jsErrorIcon && jsErrorIcon.classList.toggle('hidden', isValueValid);
      jsSuccessIcon && jsSuccessIcon.classList.toggle('hidden', !isValueValid);

      isValid = isValueValid;
    }

    if(field === 'sex'){
      var sex = inputGroup.querySelector(selectors.activeGender);
      var sex_errMsg = inputGroup.querySelector('[data-sex] [data-js-error-msg]');
      if(!sex){
        sex_errMsg.innerHTML = cache.errorMsg.empty;
        sex_errMsg.classList.remove('hidden');
        isValid = false;
      } else {
        sex_errMsg.innerHTML = '';
        sex_errMsg.classList.add('hidden');
        isValid = true;
      }
    }

    if(field === 'hasKids'){
      /*TODO AP: generic for all fields*/
      const inputName = `active${field.charAt(0).toUpperCase() + field.slice(1)}`;
      const inputElement = inputGroup.querySelector(selectors[inputName]);
      const inputErrMsg = this.container.querySelector(`[data-${field}] [data-js-error-msg]`);
      console.log('inputElement', Boolean(inputElement), inputElement);
      
      inputErrMsg.classList.toggle('hidden', inputElement);
      inputErrMsg.innerHTML = !inputElement ? cache.errorMsg.empty : '';
      isValid = Boolean(inputElement);
    }

    if(field === 'phone'){
        var phone = inputGroup.querySelector(selectors.phone);
        var phone_errMsg = inputGroup.querySelector('[data-phone] [data-js-error-msg]');
        isValid = this.validatePhoneValidateField();
        if(isValid === false){
          phone_errMsg.innerHTML = cache.errorMsg.phone;
          phone_errMsg.classList.remove('hidden');
        }
        else {
          phone_errMsg.innerHTML = '';
          phone_errMsg.classList.add('hidden');
        }
      }


    return isValid;
  }

  FidelityCard.prototype.getCounties = function(){
    const data = {'timestamp': cache.timestamp};

    var meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": cache.ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };


    fetch(cache.api.getCounties, meta).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    }).then((json) =>{
      if ([400, 402, 404, 429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429) {
        /*Errors*/
      } else {
        this.updateLocationsList(json, 'county');
      }
    }).catch((err) => {
      console.log('catch err', err);
    });
  }

  FidelityCard.prototype.getCities = function(countyId){
    const data = {
      'countyId': countyId,
      'timestamp': cache.timestamp
    };

    var meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": cache.ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(cache.api.getCities, meta).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    }).then((json) => {
      if ([400, 402, 404, 429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429) {
        /*Errors*/
      } else {
        this.updateLocationsList(json, 'city');
      }
    }).catch((err) => {
      console.log('catch err', err);
    });
  }

  /**
   * 1. Select the elements containing the locations
   * 2. Remove the input's value
   * 3. Get the search value and filter results
   * @param {('county', 'city')} location - Location to search
   */
  FidelityCard.prototype.searchLocation = function (location) {
    const parentSelector = `${location}List`;
    const locationsParent = this.container.querySelector(selectors[parentSelector]);
    const locationsArray = locationsParent.getElementsByTagName('div');

    /*If a space is added the input's value is reset*/
    const locationInput = this.container.querySelector(selectors[location]);
    locationInput.value = '';

    /*Open the dropdown again in case Enter was pressed*/
    this.toggleLocationSearch(location);
        
    const inputSelector = `${location}Search`;
    const searchQuery = this.container.querySelector(selectors[inputSelector]).value.toLowerCase().trim() || '';

    for (let location of locationsArray) {
      location.classList.toggle('hidden', !(location.innerText.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1));
      this.removeHighlight();
    }
  }

  FidelityCard.prototype.removeHighlight = function () {
    const highlight = this.container.querySelector('.js--highlight');
    if (!highlight) return;

    highlight.classList.remove('js--highlight', 'bg-blue-light', 'text-white');
  }

  /**
   * Toggle location array visibility
   * @param {('county', 'city')} location - Element to toggle
   * @param {boolean} open - Toggle status
   */
  FidelityCard.prototype.toggleLocationSearch = function (location, open = true) {
    this.removeHighlight();
    const inputSelector = `${location}Search`;
    const searchContainer = this.container.querySelector(selectors[inputSelector]);
    searchContainer.classList.toggle('rounded-t', open);
    searchContainer.classList.toggle('rounded', !open);

    const parentSelector = `${location}List`;
    const listParent = this.container.querySelector(selectors[parentSelector])
    listParent.classList.toggle('hidden', !open);
    listParent.classList.toggle(selectors.openedListClass, open);
  }

  /**
   * Updates locationsParent with corresponding values
   * @param {object} locationsArray - Array of locations containing name and id keys
   * @param {('county', 'city')} location - Translated into 'județ' or 'oraș'
   */
  FidelityCard.prototype.updateLocationsList = function (locationsArray, location) {
    const tempDiv = document.createElement('div');

    locationsArray.map((entry) => {
      const div = document.createElement('div');
      div.className = 'p-1 cursor-pointer hover:bg-blue-light hover:text-white';
      div.innerText = entry.name;
      div.setAttribute(`${location}-id`, entry.id);
      div.setAttribute(`${location}-name`, entry.name);
      tempDiv.appendChild(div);
    });
    
    /*Add the default "disabled" value when emptying the city list*/
    if (location === 'city' && locationsArray.length === 0) {
      const div = document.createElement('div');
      div.className = 'p-2 text-indigo';
      div.innerText = 'Trebuie sa alegi un județ';
      tempDiv.appendChild(div);
    }

    const parentSelector = `${location}List`;
    this.container.querySelector(selectors[parentSelector]).innerHTML = tempDiv.innerHTML;
  }

  FidelityCard.prototype.existCardValidateField = function(field){
    var isValid = true;
    var inputGroup = this.container.querySelector(selectors.existCardWrapper);
    var cardElem = inputGroup.querySelector(selectors.card);
    var jsErrorIcon = inputGroup.querySelector(selectors.jsErrorIcon);
    var jsSuccessIcon = inputGroup.querySelector(selectors.jsSuccessIcon);
    var errMsg = inputGroup.querySelector(selectors.errorMsg);

    var inputVal = cardElem.value.trim();
    isValid = theme.Helpers.validateWithRegex(inputVal, cache.regex.card);
    if(!isValid) errMsg.innerHTML = cache.errorMsg.card;

    if(inputVal.length === 0){
      errMsg.innerHTML = cache.errorMsg.empty;
      isValid = false;
    }

    if(isValid){
      cardElem.classList.remove('input--error');
      if(errMsg) {
        errMsg.innerHTML = '';
        errMsg.classList.add('hidden');
      }
      if(jsErrorIcon) jsErrorIcon.classList.add('hidden');
      if(jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
    } else {
      cardElem.classList.add('input--error');
      if(errMsg) errMsg.classList.remove('hidden');
      if(jsErrorIcon) jsErrorIcon.classList.remove('hidden');
      if(jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
    }

    return isValid;
  }

  FidelityCard.prototype.submitForm = function(evt){
    evt.preventDefault();
    if(!cache.activeSection) return;
    if(this.loginModel){
      this.toggleLoginModel(1);
      return;
    }

    switch(cache.activeSection){
      case 'customer[note][CARD_]': 
        this.validateCard();
        break;
      case 'customer[note][Enroll Loyalty Program]':
        this.issueNewCard();
        break;
    }
  }

  FidelityCard.prototype.validateCard = function(){
    var isValid =  this.validatePhoneValidateField('exist') && this.existCardValidateField();

    if(!isValid) return;

    this.showLoading(1, 'exist_card');
    var self = this;
    var email = this.container.querySelector(selectors.email).value;
    var phone = this.container.querySelector(selectors.exist_phone).value;
    var card_num = this.container.querySelector(selectors.card).value;
    var success_msg = cache.successMsg.default;

    if(!email || !card_num) return;

    var data = {
      "email": email,
      "phone": phone,
      "timestamp": cache.timestamp,
      "fidelityCardNo": card_num
    };

    var meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": cache.ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(cache.api.validate_card, meta).then(function(res){
      if(res.ok){
        return res;
      } else {
        return res.json();
      }
    }).then(function(json){
   
      if([400,402,404,429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429){
        self.displayResponse(json); 
      } else {
        self.showHideResponse(1, success_msg, 1);
        setTimeout(function(){
          window.location.reload();
        }, 2500);
      }

      self.showLoading(0, 'exist_card');
    }).catch(function(err){
      self.showLoading(0, 'exist_card');
    });
  }

  FidelityCard.prototype.issueNewCard = function(){
    var isDOBValid = this.newCardValidateField('dob');
    var isSexValid = this.newCardValidateField('sex');
    var isHasKidsValid = this.newCardValidateField('hasKids');
    var isPhoneValid = this.newCardValidateField('phone');
    var isCountyValid = this.newCardValidateField('county');
    var isCityValid = this.newCardValidateField('city');

    if(!isDOBValid || !isSexValid || !isHasKidsValid || !isPhoneValid || !isCountyValid || !isCityValid) return;

    this.showLoading(1, 'new_card');
    var self = this;
    var email = this.container.querySelector(selectors.email).value;
    var phone = this.container.querySelector(selectors.phone).value;
    var hasKids = this.container.querySelector(selectors.activeHasKids).value === 'true';
    var sex = this.container.querySelector(selectors.activeGender).value;
    var bday = this.container.querySelector(selectors.DOB).value;
    var county = this.container.querySelector(selectors.county).value;
    var city = this.container.querySelector(selectors.city).value; 
    
    if(!email || !bday) return;
    
    var success_msg = cache.successMsg.default;
    // var birthday = bday.split('-').reverse().join('/');

    var data = {
      "email": email,
      "hasKids": hasKids,
      "sex": sex,
      "birthday": bday,
      "phone" : phone,
      "county": county,
      "city": city,
      "timestamp": cache.timestamp,
    };
    console.log('data', data);


    var meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": cache.ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(cache.api.issue_new_card, meta).then(function(res){
      if(res.ok){
        return res;
      } else {
        return res.json();
      }
    }).then(function(json){
      if([400,402,404,429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429){
        self.displayResponse(json); 
      } else {
        self.showHideResponse(1, success_msg, 1);
        setTimeout(function(){
          window.location.reload();
        }, 2500);
      }
      self.showLoading(0, 'new_card');
    }).catch(function(err){
      self.showLoading(0, 'new_card');
    });
  }

  FidelityCard.prototype.displayResponse = function(json){
    var message = json.message;
    if(json.error || json.status === 400){
      var tempDiv = document.createElement('div');
      if(Array.isArray(message)){
        message.map(function(msg){
          var div = document.createElement('div');
          div.textContent = msg;
          tempDiv.appendChild(div);
        });
      } else {
        if(typeof message === 'string'){
          var div = document.createElement('div');
          div.textContent = message;
          tempDiv.appendChild(div);
        }
      }

      this.showHideResponse(1, tempDiv.innerHTML);
    }
  }

  FidelityCard.prototype.showHideResponse = function(show, msg, success){
    var activeElem = this.container.querySelector(selectors.activeOptionalRadio);
    var inputGroup = activeElem.closest(selectors.inputGroup);
    var resWrapper = inputGroup.querySelector(selectors.resWrapper);
    var resSuccessWrapper = document.querySelector(selectors.resSuccessWrapper);
    var elem = resWrapper;

    if(success){
      elem = resSuccessWrapper;
      resWrapper.classList.remove('bg-red-light');
      resWrapper.classList.add('bg-blue-light');
    } else {
      resWrapper.classList.add('bg-red-light');
      resWrapper.classList.remove('bg-blue-light');
      elem.innerHTML = msg;
    }

    if(show) elem.classList.remove('hidden'); 
    else resWrapper.classList.add('hidden'); 

    if(success) window.scroll({top: 0, behavior: "smooth"});
  }
  
  return FidelityCard;
})();

/**
 * Handles loyalty points and vouchers
 * @type {LoyaltyVoucher}
 */
theme.LoyaltyVoucher = (function () {
  const selectors = {
    /*Cart*/
    pointInput: '#loyalty-points',
    cartModal: '#loyalty-modal',
    cartModalClose: '#loyalty-modal-close',
    submitButton: '#loyalty-get-voucher',


    jsErrorIcon: '[data-js-error-icon]',
    jsSuccessIcon: '[data-js-success-icon]',
    errorMsg: '[data-js-error-msg]',

    errorWrapper: '.data-error-wrapper',

    /*Account*/
    vouchersList: '#voucher-list',
    pointsHistoryHeading: '#points-list-heading',
    pointsHistory: '#points-list'
  };

  const cache = {
    api: {
      createVoucher: apiBaseUrl + '/api/vouchers',
      getVouchers: apiBaseUrl + '/api/vouchers',
      getPointsHistory: apiBaseUrl + '/api/customer/points',
    },
    errorMsg: {
      points: 'Numarul de puncte este invalid',
      empty: 'Acest camp este obligatoriu'
    },
    regex: {
      input: /^[0-9]*$/
    },
    successMsg: {
      default: 'Succes'
    },
  }
  /*Remove timeout after copying voucher*/
  let timer;

  function LoyaltyVoucher(container) {
    this.container = container;

    cache.timestamp = this.container.querySelector('[name="x-shopify_time"]').value;
    cache.ss = this.container.querySelector('[name="x-shopify_sstr"]').value;

    if (this.container.querySelector(selectors.pointInput)) this.initGenerateVoucher();
    if (this.container.querySelector(selectors.vouchersList)) this.initVoucherList();
    if (this.container.querySelector(selectors.pointsHistory)) this.iniPointsHistory();
  }

  LoyaltyVoucher.prototype.initVoucherList = function () {
    const self = this;
    self.getVouchers();
  }

  LoyaltyVoucher.prototype.iniPointsHistory = function () {
    const self = this;
    self.getPointsHistory();
  }

  LoyaltyVoucher.prototype.initGenerateVoucher = function () {
    const self = this;

    this.submitButton = this.container.querySelector(selectors.submitButton);
    this.modal = this.container.querySelector(selectors.cartModal);

    const inputElement = this.container.querySelector(selectors.pointInput);
    const modalClose = this.container.querySelector(selectors.cartModalClose);

    inputElement.addEventListener('input', function () {
      self.validatePointsField();
    });
    modalClose.addEventListener('click', (e) => {
      e.preventDefault();
      this.modal.classList.add('hidden');
      this.modal.classList.remove('js-error');
    });
    this.submitButton.addEventListener('click', (e) => {
      e.preventDefault();
      self.getVoucher();
    });
  }

  LoyaltyVoucher.prototype.validatePointsField = function () {
    let isValid;

    const inputElement = this.container.querySelector(selectors.pointInput);
    const jsErrorIcon = this.container.querySelector(selectors.jsErrorIcon);
    const jsSuccessIcon = this.container.querySelector(selectors.jsSuccessIcon);
    const errMsg = this.container.querySelector(selectors.errorMsg);

    const inputVal = inputElement.value.trim();
    isValid = theme.Helpers.validateWithRegex(inputVal, cache.regex.input)
      && (Number(inputVal) <= loyalty.points)
      && (Number(inputVal) !== 0);
    if (!isValid) errMsg.innerHTML = cache.errorMsg.points;

    if (inputVal.length === 0) {
      errMsg.innerHTML = cache.errorMsg.empty;
      isValid = false;
    }

    if (isValid) {
      inputElement.classList.remove('input--error');
      if (errMsg) {
        errMsg.innerHTML = '';
        errMsg.classList.add('hidden');
      }
      if (jsErrorIcon) jsErrorIcon.classList.add('hidden');
      if (jsSuccessIcon) jsSuccessIcon.classList.remove('hidden');
    } else {
      inputElement.classList.add('input--error');
      if (errMsg) errMsg.classList.remove('hidden');
      if (jsErrorIcon) jsErrorIcon.classList.remove('hidden');
      if (jsSuccessIcon) jsSuccessIcon.classList.add('hidden');
    }

    return isValid;
  }

  LoyaltyVoucher.prototype.getVoucher = function () {
    let isValid = this.validatePointsField();
    if (!isValid) return;

    const inputElement = this.container.querySelector(selectors.pointInput);
    const inputVal = inputElement.value.trim();
    const data = {
      'customerId': user.id,
      'pointsToReduce': inputVal,
      'timestamp': cache.timestamp
    };

    const meta = {
      method: 'POST',
      headers: {
        "X-Shopify-Shop-Domain": Shopify.shop,
        "X-Shopify-Hmac-Sha256": cache.ss,
        "Accept": "application/json",
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    this.showLoading();
    fetch(cache.api.createVoucher, meta).then((res) => {
      if (res.ok) {
        return res;
      } else {
        return res.json();
      }
    }).then((json) => {
      if ([400, 402, 404, 429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429) {
        this.showErrorResponse(json);
      } else {
        this.modal.classList.remove('hidden', 'js-error');
        loyalty.points -= inputVal;
        loyalty.setPointsTo(['#loyalty-header-points', '#loyalty-cart-points', '#loyalty-description-points']);
        inputElement.value = '';
        /*Update the voucher list (cart and account)*/
        if (this.container.querySelector(selectors.vouchersList)) this.getVouchers();
      }

    }).finally(() => {
      this.showLoading(false);
    });
  }

  LoyaltyVoucher.prototype.showErrorResponse = function (json) {
    this.modal.classList.add('js-error');
    let message = json.message;
    const tempDiv = document.createElement('div');
    if (typeof message === 'string') message = [message];

    message.map(function (msg) {
      const div = document.createElement('div');
      div.textContent = msg;
      tempDiv.appendChild(div);
    });

    const errorWrapper = this.container.querySelector(selectors.errorWrapper);
    errorWrapper.innerHTML = tempDiv.innerHTML;
    this.modal.classList.remove('hidden');
  }

  LoyaltyVoucher.prototype.showLoading = function (show = true) {
    this.submitButton.querySelector('[data-text]').classList.toggle('hide', show);
    this.submitButton.querySelector('[data-loader]').classList.toggle('hide', !show);
    this.submitButton.disabled = show;
  }

  /*Account*/
  LoyaltyVoucher.prototype.getVouchers = function () {
    const data = {'timestamp': cache.timestamp};
    const meta = {
      method: 'POST',
      headers: {
        'X-Shopify-Shop-Domain': Shopify.shop,
        'X-Shopify-Hmac-Sha256': cache.ss,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };
    
    fetch(`${cache.api.getVouchers}/${user.id}`, meta).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    }).then((json) => {
      if ([400, 402, 404, 429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429) {
        // Error
      } else {
        this.listVouchers(json);
      }
    });
  }

  LoyaltyVoucher.prototype.listVouchers = function (vouchers) {
    /*Display a different template in cart*/
    if (this.container.querySelector(selectors.vouchersList).classList.contains('cart-vouchers')) {
      this.listCartVouchers(vouchers);
      return;
    }

    if (!vouchers.length) {
      this.container.querySelector(selectors.vouchersList).innerHTML = `
        <div class="mx-5 md:mx-0 mb-5 md:mb-6">
          <p class="text-loyalty-red w-full mb-1 text-sm md:text-base">
              Inca nu ai vouchere generate
            </p>
          </div>`;
      return
    }
    const tempDiv = document.createElement('div');
    const voucherInfo = document.createElement('p');
    voucherInfo.className = 'text-sm text-black-black mb-4 mx-5 md:mx-0';
    voucherInfo.innerHTML = `Voucherele nefolosite expira in ziua generarii, la ora 23:59, iar punctele sunt returnate in cont.`;
    tempDiv.appendChild(voucherInfo);

    vouchers.map((voucher) => {
      const div = document.createElement('div');
      div.className = 'voucher flex flex-wrap pb-5 md:pb-6 mx-5 md:mx-0 mb-5 md:mb-6 border-b';
      div.innerHTML = `
        <p class="w-full md:w-1/2 mb-4 font-bold text-sm md:text-base flex-grow order-1 md:order-none">
          <span class="hidden md:inline-block">Cod voucher: </span><span id="voucher-${voucher.code}" >${voucher.code}</span>
        </p>
        <p class="mb-4 flex-grow text-right text-sm text-gray-light order-3 md:order-none">
          expira la: ${voucher.endDate.split('T')[0]}
        </p>
        <p class="text-loyalty-red mb-4 md:mb-0 flex-grow font-bold md:w-1\/2 text-base md:text-2xl self-center order-2 md:order-none">
          ${voucher.value} ${voucher.value > 1 ? 'lei' : 'leu'}
        </p>
        <button onclick="theme.LoyaltyVoucher.prototype.copyVoucher(event, '${voucher.code}')" class="success-copy w-full md:w-auto order-4 md:order-none btn outline-none bg-green hover:bg-green text-white hover:text-white border border-green hover:border-green hover:shadow-btn-hover transition duration-150 ease-in rounded text-sm font-bold flex justify-center items-center">
          Copiaza acest voucher
        </button>
        <p class="mt-3 flex-grow text-right text-xs text-gray-light order-5">
          si introdu-l in cosul de cumparaturi in sectiunea "Ai un voucher?"
        </p>
      `;
      tempDiv.appendChild(div);
    });

    this.container.querySelector(selectors.vouchersList).innerHTML = tempDiv.innerHTML;
  }


  LoyaltyVoucher.prototype.listCartVouchers = function (vouchers) {
    if (!vouchers.length) {
      this.container.querySelector(selectors.vouchersList).innerHTML = '<div class="bg-white rounded-card border border-gray-light-xs p-3 text-left"><p class="text-loyalty-red w-full mb-1 text-base">Inca nu ai vouchere generate</p></div>';
      return
    }

    const tempDiv = document.createElement('div');

    vouchers.map((voucher) => {
      const div = document.createElement('div');
      div.className = 'bg-white rounded-card border border-gray-light-xs p-3 mb-4 text-left';
      div.innerHTML = `
        <p class="text-loyalty-red w-full mb-1 text-base">
          <span>${voucher.value} ${voucher.value > 1 ? 'lei' : 'leu'}</span>
        </p>
        <p class="text-gray-light w-full mb-2 text-xs">
          <span id="voucher-${voucher.code}" class="font-bold">${voucher.code}</span><br>
          expira la: ${voucher.endDate.split('T')[0]}
        </p>
        <button onclick="theme.LoyaltyVoucher.prototype.copyVoucher(event, '${voucher.code}')" class="success-copy p-1 uppercase w-full bg-transparent text-green border border-green hover:shadow-btn-hover transition duration-150 ease-in rounded text-xs font-bold flex justify-center items-center">
          Copiaza
        </button>
      `;
      tempDiv.appendChild(div);
    });

    this.container.querySelector(selectors.vouchersList).innerHTML = tempDiv.innerHTML;
  }

  LoyaltyVoucher.prototype.copyVoucher = function (event, voucher) {
    event.preventDefault();
    event.target.classList.remove('run-animation');
    const range = document.createRange();
    const selection = window.getSelection();
    range.selectNode(document.getElementById(`voucher-${voucher}`));
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    event.target.classList.add('run-animation');
    selection.removeAllRanges();

    timer = window.setTimeout(function () {
      event.target.classList.remove('run-animation');
    }, 1600);
  };


  LoyaltyVoucher.prototype.getPointsHistory = function () {
    const data = {'timestamp': cache.timestamp};
    const meta = {
      method: 'POST',
      headers: {
        'X-Shopify-Shop-Domain': Shopify.shop,
        'X-Shopify-Hmac-Sha256': cache.ss,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    };

    fetch(`${cache.api.getPointsHistory}/${loyalty.card_no}`, meta).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return res;
      }
    }).then((json) => {
      if ([400, 402, 404, 429].indexOf(json.status) > -1 || json.error || json.statusCode === 400 || json.statusCode === 429) {
        this.container.querySelector(selectors.pointsHistory).innerHTML = "Inca nu ai plasat comenzi in programul de fidelitate!";
      } else {
        this.listPointsHistory(json);
      }

    }).finally(() => {
      /*Hide loader*/
    });
  }
  
  LoyaltyVoucher.prototype.listPointsHistory = function (points) {
    const tempDiv = document.createElement('div');
    points.map(function (point, index) {
      const div = document.createElement('div');
      const rowClass = index % 2 === 0
        ? 'bg-white'
        : 'bg-green bg-opacity-20';
      div.className = `${rowClass} border-indigo-light border border-t-0 flex`;
      div.innerHTML = `
          <div class="border-r border-indigo-light w-1/4 p-1 md:px-4 md:py-2">${point.addedDate}</div>
          <div class="border-r border-indigo-light w-1/4 p-1 md:px-4 md:py-2">${point.orderValue || 0}</div>
          <div class="border-r border-indigo-light w-1/4 p-1 md:px-4 md:py-2">${Math.ceil(point.points)}</div>
          <div class="w-1/4 p-1 md:px-4 md:py-2">${point.expirationDate}</div>
      `;
      tempDiv.appendChild(div);
    });

    this.container.querySelector(selectors.pointsHistory).innerHTML = tempDiv.innerHTML;
    this.container.querySelector(selectors.pointsHistoryHeading).classList.remove('hidden');
  }

  return LoyaltyVoucher;
})();

// Search page ajax functionality
theme.SearchAjax = (function(){
  var selectors = {
    productsWrapper: "#search-products-wrapper .list-view-items",
    articlesWrapper: "#search-articles-wrapper .list-view-items",
    productLoadmore: "[data-products-loadmore]",
    articleLoadmore: "[data-articles-loadmore]",
    productCount: "[data-product-tab] [data-count]",
    articleCount: "[data-article-tab] [data-count]",
    tab:'[data-tab]',
    tabContent:'[data-tab-content]',
    addToCart: '[data-add-to-cart]',
    mainLoader: '.loader-lg'    
  };

  var cache = {
    resultPerPage: 50,
    maxArticlePages: 10,
    letterVariants: 12,
    searchUrl: '/search?options%5Bprefix%5D=last&view=json&q=',
    productHtml: '<li class="w-full px-1 md:px-3 rounded-xl mb-4 md:mb-7">'+
                    '<div '+
                        'class="grid-view-item m-0 pt-4 pb-4 md:pb-8 bg-white rounded-card md:rounded-xl card-shadow  product-card flex flex-col h-full"'+
                        'data-limoniapps-discountninja-product-handle="{{handle}}" '+
                        'data-limoniapps-discountninja-product-collections="{{collections}}" '+
                        'data-limoniapps-discountninja-product-available="{{available}}" '+
                        'data-limoniapps-discountninja-product-price="{{price}}" '+
                        'data-limoniapps-discountninja-product-compareatprice="{{compare_at_price}}" '+
                        'data-limoniapps-discountninja-product-pricevaries="{{pricevaries}}" '+
                        'data-limoniapps-discountninja-product-pricemin="{{pricemin}}" '+                       
                        'data-limoniapps-discountninja-product-tags="{{tags}}">'+
                        

                        '<a href="{{url}}" title="{{title}}" class="block clear-both">'+
                            '<div class="product-card__image-with-placeholder-wrapper limoniapps-discountninja-collectionbadge">'+
                                '<div id="ProductCardImageWrapper-search-template-{{id}}" class="grid-view-item__image-wrapper product-card__image-wrapper js relative">'+
                                    '<div class="relative">'+
                                        '<img '+
                                            'id="ProductCardImage-search-template-{{id}}" '+
                                            'class="grid-view-item__image lazyload max-w-full object-contain w-full max-h-full" '+
                                            'alt="{{title}}" '+
                                            'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" '+
                                            'data-aspectratio="1.0" '+
                                            'data-sizes="auto" '+
                                            'data-image="" '+
                                            'sizes="134px" '+
                                            'data-src="{{img_src}}" '+
                                            'src="{{img_src}}" />'+
                                    '</div>'+
                                '</div>'+
                              '{{{labels.long_label}}}'+
                              '{{{labels.badge_label}}}'+
                            '</div>'+
                        '</a>'+

                        '<noscript><img class="grid-view-item__image" src="{{img_src}}" /></noscript>'+

                        '<div class="product-card__info mx-auto w-full md:w-2/3 text-left flex flex-col flex-grow">'+
                            '<div class="product-card__info-top px-2.5">'+
                                '<a href="{{url}}" class="block">'+
                                    '<h2 class="h4 block grid-view-item__title product-card__title h-12 overflow-hidden text-xs sm:text-sm md:text-base leading-5 md:leading-6 font-normal md:text-center border-0 hover:border-0 no-underline hover:no-underline tracking-normal text normal-case" '+
                                        'aria-hidden="true">'+
                                        '{{title}}'+
                                    '</h2>'+
                                '</a>'+
                                '<small class="product-weight w-full h-5 overflow-hidden whitespace-nowrap block text-xs md:text-sm leading-5 font-light md:font-normal md:text-center mt-1 text-indigo">'+
                                    '{{prezentare}}'+
                                '</small>'+
                            '</div>'+
                            '<div class="product-card__info-bottom pt-2 md:pt-3.5 px-2.5 mt-auto">'+
                                '{{#if judgeme_html}}'+
                                  '<div class="judgeme-listing flex justify-center mb-1">{{{judgeme_html}}}</div>'+
                                '{{/if}}'+
                                '{{{labels.short_label}}}'+
                                '<dl class="price price--listing items-start md:items-center ">'+
                                    '<div class="price__regular m-0">'+
                                        '<dt class="m-0">'+
                                            '<span class="visually-hidden visually-hidden--inline">Pret obisnuit</span>'+
                                        '</dt>'+
                                        '<dd>'+
                                            '<span class="price-item price-item--regular text-base text-black text-opacity-80 font-medium m-0 limoniapps-discountninja-productprice">{{price_formatted}}</span>'+
                                        '</dd>'+
                                    '</div>'+
                                '</dl>'+
                                '<div class="mt-2 md:mt-3.5">'+
                              ' {{#if available}}'+
                               
                                '<form action="/cart/add" method="post" enctype="multipart/form-data" class="pt-0 product-form product-form-product-template product-form--payment-button-no-variants" data-product-form="" >'+
                                    '<input type="hidden" name="id" value="{{c_vid}}" />'+
                                    '<button '+
                                        'type="submit" '+
                                        'name="add" '+
                                        'aria-label="Adauga in cos" '+
                                        'class="product-form__cart-submit bg-white text-red transition duration-150 ease-in-out font-semibold border hover:border-2 border-solid border-red hover:bg-white focus:outline-none focus:border-3 rounded text-xs m-0" '+
                                        'aria-haspopup="dialog" '+
                                        'data-add-to-cart="">'+
                                        '<span data-text class="text-red font-semibold pointer-events-none">Adauga in cos</span>'+
                                        '<span class="hide pointer-events-none" data-loader>'+
                                            '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20">'+
                                                '<path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path>'+
                                            '</svg>'+
                                        '</span>'+
                                    '</button>'+

                                    '{{#if is_new_bundle}}'+
                                      '<script type="application/json" id="ProductNewBundleJson-s-{{c_vid}}">'+
                                          '{{{item_properties}}}'+
                                      '</script>'+
                                    '{{/if}}'+
                                '</form>'+
                                '{{else}}'+                             
                                 '<a href="{{url}}" name="stockalert"  class="flex items-center justify-center transition duration-150 ease-in-out product-form__cart-submit bg-white focus:border focus:outline-none hover:bg-white text-blue font-semibold border hover:border-2 border-solid border-blue rounded text-xs m-0"'+
                                   '<span class="text-blue font-semibold">Produs indisponibil</span>'+
                                   '<span class="hide" data-loader="">'+
                                         '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner " viewBox="0 0 20 20"> <path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path> </svg>'+
                                   '</span>'+
                                 '</a>'+
                                '{{/if}}'+

             
                                '</div>'+
                            '</div>'+
                        '</div>'+
                    '</div>'+
                '</li>',

    articleHtml: '<div class="article-card relative article-card--list mb-10 md:mb-5">'+
                    '<a href="{{url}}" class="full-width-link block md:hidden">'+
                      '<span class="visually-hidden">{{title}}</span>'+
                    '</a>'+
                    '<div class="list-view-item__link">'+
                        '<div class="list-view-item__image-column">'+
                            '<div class="list-view-item__image-wrapper product-card__image-wrapper">'+
                                '<img src="{{img_src}}" alt="{{title}}" class="list-view-item__image w-full h-full object-contain" />'+
                            '</div>'+
                        '</div>'+
                        '<div class="list-view-item__title-column">'+
                            '<div class="list-view-item__title" aria-hidden="true">'+
                                '<span class="product-card__title text-black font-medium">{{title}}</span>'+
                            '</div>'+
                            '<div class="break-all">{{content}}</div>'+
                        '</div>'+
                        '<div class="list-view-item__price-column hidden md:table-cell">'+
                            '<a href="{{url}}" class="view-details-cta ml-0 md:ml-auto flex justify-center items-center rounded text-sm text-center text-black-clay p-2 w-3/4 md:w-28 h-10 border border-solid border-green hover:border-2 bg-white focus:bg-white focus:border-green outline-none focus:outline-none">'+
                                '<span>vezi detalii</span>'+
                            '</a>'+
                        '</div>'+
                    '</div>'+
                '</div>'
  };

  function SearchAjax(container){
    var no_result = container.querySelector('.search--no-results-found');
    if(!no_result){
      this.container = container;
      var q = theme.Helpers.getParamFromURL('q');
      if(q) this.fetchResult(q);
    }
  }

  SearchAjax.prototype.init = function(data){
    this.eventHandlers = {};

    this.products = data.products;
    this.articles = data.articles;

    // Open the tab that has results when the other one is empty
    var forcedTab = null;
    if(!this.products.length && this.articles.length) forcedTab = '#search-articles-wrapper';
    if(!this.articles.length && this.products.length) forcedTab = '#search-products-wrapper';

    this.container.querySelector(selectors.productCount).innerHTML = '(' + this.products.length + ')';
    this.container.querySelector(selectors.articleCount).innerHTML = '(' + this.articles.length + ')';
    
    if(this.products.length > cache.resultPerPage){
      this.updateCTAEvents('products_load_more');
    }
    if(this.articles.length > cache.resultPerPage){
      this.updateCTAEvents('articles_load_more');
    }

    this.updateProducts();
    this.updateArticles();
    this.initTabs(forcedTab);
    this.initEvent();
    var mainLoader = this.container.querySelector(selectors.mainLoader);
    mainLoader.classList.add('hide');
  }

  SearchAjax.prototype.initEvent = function(section){
    var addToCart = this.container.querySelectorAll(selectors.addToCart);
    if(addToCart && addToCart.length){
      addToCart.forEach(function(cta){
        cta.addEventListener('click', function(evt){
          evt.preventDefault();
          var self = this;
          var vid = this.closest('form').querySelector('[name="id"]').value;
     
          if(vid){
            this.querySelector('[data-text]').classList.add('hide');
            this.querySelector('[data-loader]').classList.remove('hide');
            this.disabled = false;

            var formData = {
              items: [{
                quantity: 1,
                id: vid
              }]
            };

            const newBundleJson = this.closest('form').querySelector('#ProductNewBundleJson-s-'+vid)
            if (newBundleJson) {
              formData.items[0].properties = JSON.parse(newBundleJson.innerHTML);
            }
    
  
            window.AjaxCart.addItems(
              formData,
              function () {
                self.querySelector('[data-text]').classList.remove('hide');
                self.querySelector('[data-loader]').classList.add('hide');
                self.disabled = false;
              },
              function () {
                self.querySelector('[data-text]').classList.remove('hide');
                self.querySelector('[data-loader]').classList.add('hide');
                self.disabled = false;
              }
            );
          }
        });
      });
    }
  }

  SearchAjax.prototype.initTabs = function(forcedTab){
    var tabs = this.container.querySelectorAll(selectors.tab);
    var tabContens = this.container.querySelectorAll(selectors.tabContent);

    if(tabs && tabs.length){
      if(window.sessionStorage) {
        var active_tab = forcedTab || sessionStorage.getItem("searchTab");
        if(active_tab){
          var elem = selectors.tab + '[data-target="'+ active_tab +'"]'
          var tab = document.querySelector(elem);
          if(tab){
            hideTabs();
            tab.classList.add('active');
            document.querySelector(active_tab).classList.add('active');
          }
        } else {
          tabs[0].classList.add('active');
          tabContens[0].classList.add('active');
        }
      }

      function hideTabs(){
        tabs.forEach(function(tab){
          tab.classList.remove('active');
        });
        tabContens.forEach(function(content){
          content.classList.remove('active');
        });
      }

      tabs.forEach(function(tab){
        tab.addEventListener('click', function(evt){
          hideTabs();
          var target = this.dataset.target;
          evt.target.classList.add('active');
          document.querySelector(target).classList.add('active');
          if(window.sessionStorage) sessionStorage.setItem("searchTab", target);
        })
      })
    }
  }

  SearchAjax.prototype.updateLoadingState = function(target, show){
    if(show){
      target.querySelector('[data-text]').classList.add('hide');
      target.querySelector('[data-loader]').classList.remove('hide');
      target.disabled = true;
    } else {
      target.querySelector('[data-text]').classList.remove('hide');
      target.querySelector('[data-loader]').classList.add('hide');
      target.disabled = false;
    }
  }

  SearchAjax.prototype.updateCTAEvents = function(cta, destroy){
    if(!cta) return;

    if(cta === 'products_load_more'){
      var productLoadmore = this.container.querySelector(selectors.productLoadmore);
      if(!destroy){
        productLoadmore.classList.remove('hide');
        this.eventHandlers.updateProducts = this.updateProducts.bind(this);
        productLoadmore.addEventListener('click', this.eventHandlers.updateProducts, false);
      } else {
        productLoadmore.removeEventListener('click', this.eventHandlers.updateProducts, false);
        productLoadmore.classList.add('hide');
      }
    }

    if(cta === 'articles_load_more'){
      var articleLoadmore = this.container.querySelector(selectors.articleLoadmore);
      if(!destroy){
        articleLoadmore.classList.remove('hide');
        this.eventHandlers.updateArticles = this.updateArticles.bind(this);
        articleLoadmore.addEventListener('click', this.eventHandlers.updateArticles, false);
      } else {
        articleLoadmore.removeEventListener('click', this.eventHandlers.updateArticles, false);
        articleLoadmore.classList.add('hide');
      }
    }
  }

  SearchAjax.prototype.updateProducts = function(evt){
    var self = this;
    var currentTarget = null;
    if(evt) {
      currentTarget = evt.currentTarget;
      this.updateLoadingState(currentTarget, 1);
    }

    if(this.products.length > 0){
      var products = this.products.splice(0, cache.resultPerPage);
      this.buildAndUpdateProductHtml(products);

      if(this.products.length === 0){
        this.updateCTAEvents('products_load_more', 1);
      }

    } else {
      this.updateCTAEvents('products_load_more', 1);
    }

    if(currentTarget) {
      setTimeout(function(){
        self.updateLoadingState(currentTarget, 0);
      }, 1000);
    }
  }

  SearchAjax.prototype.buildAndUpdateProductHtml = function(products){
    var productsHtml = '';
    var productsWrapper = this.container.querySelector(selectors.productsWrapper);
    var productCardTemplate = window.Handlebars.compile(cache.productHtml);
    
    products.map(function(product){
      if(product){

        var productHtml = productCardTemplate({
            title: product.title,
            url: product.url,
            img_src: product.image,
            collections: product.collections.toString(),
            available: JSON.parse(product.available),
            price: product.price,
            price_formatted: theme.Currency.formatMoney(product.price, theme.moneyFormat),
            compare_at_price: product.compare_at_price || '',
            pricevaries: product.price_varies,
            pricemin: product.price_min,
            tags: product.tags.toString() || '',
            handle: product.handle,
            id: product.id,
            prezentare: product.prezentare || '',
            c_vid: product.c_vid,
            is_new_bundle: product.is_new_bundle,
            item_properties: JSON.stringify(product.item_properties || {}),
            judgeme_html: product.judgeme_html || '',
            labels: product.labels,
        })

        productsHtml += productHtml;
      }
    });

    if(productsHtml != ''){
      var existHtml = productsWrapper.innerHTML;
      productsWrapper.innerHTML = existHtml + productsHtml;
      this.initEvent();
    }
  }

  SearchAjax.prototype.updateArticles = function(evt){
    var self = this;
    var currentTarget = null;
    if(evt) {
      currentTarget = evt.currentTarget;
      this.updateLoadingState(currentTarget, 1);
    }

    if(this.articles.length > 0){
      var articles = this.articles.splice(0, cache.resultPerPage);
      this.buildAndUpdateArticleHtml(articles);

      if(this.articles.length === 0){
        this.updateCTAEvents('articles_load_more', 1);
      }
    } else {
      this.updateCTAEvents('articles_load_more', 1);
    }

    if(currentTarget) {
      setTimeout(function(){
        self.updateLoadingState(currentTarget, 0);
      }, 1000);
    }
  }

  SearchAjax.prototype.buildAndUpdateArticleHtml = function(articles){
    var articlesHtml = '';
    var articlesWrapper = this.container.querySelector(selectors.articlesWrapper);

    articles.map(function(article){
      if(article){
        var articleHtml = cache.articleHtml;
        articleHtml = theme.Helpers.updateHtml(articleHtml, '{{title}}', article.title);
        articleHtml = theme.Helpers.updateHtml(articleHtml, '{{url}}', article.url);
        articleHtml = theme.Helpers.updateHtml(articleHtml, '{{img_src}}', article.image);
        articleHtml = theme.Helpers.updateHtml(articleHtml, '{{content}}', (article.content || ''));
        articlesHtml += articleHtml;
      }
    });

    if(articlesHtml != ''){
      var existHtml = articlesWrapper.innerHTML;
      articlesWrapper.innerHTML = existHtml + articlesHtml;
    }
  }

  SearchAjax.prototype.fetchJson = function(url){
    return fetch(url).then(function(res){
      if(!res.ok) throw new Error('Search request failed: ' + res.status);
      return res.json();
    });
  }

  // A vitamin letter ("vitamina c") is matched by Shopify anywhere in the text, so almost
  // every article mentioning "vitamina" comes back. Search it as an exact phrase together
  // with its numbered forms instead: "vitamina d" -> ("vitamina d" OR "vitamina d1" ... "vitamina d12")
  SearchAjax.prototype.buildArticleQuery = function(q){
    if(/["()]|\bOR\b/.test(q)) return q;

    var words = q.trim().split(/\s+/);
    var changed = false;

    for(var i = 1; i < words.length; i++){
      if(/^[a-z]$/i.test(words[i]) && /^vitamin/i.test(words[i - 1])){
        var phrase = words[i - 1] + ' ' + words[i];
        var variants = ['"' + phrase + '"'];
        for(var n = 1; n <= cache.letterVariants; n++){
          variants.push('"' + phrase + n + '"');
        }
        words[i - 1] = '(' + variants.join(' OR ') + ')';
        words[i] = '';
        changed = true;
      }
    }

    return changed ? words.filter(Boolean).join(' ') : q;
  }

  // Falls back to the query as typed when the vitamin phrase finds nothing
  SearchAjax.prototype.fetchArticles = function(q){
    var self = this;
    var articleQuery = this.buildArticleQuery(q);
    if(articleQuery === q) return this.fetchArticlePages(q);

    return this.fetchArticlePages(articleQuery).catch(function(){
      return [];
    }).then(function(articles){
      return articles.length ? articles : self.fetchArticlePages(q);
    });
  }

  // A mixed search returns only the top 2 articles next to the products, so articles
  // are fetched on their own (type=article) and from every page (max 250 results/page)
  SearchAjax.prototype.fetchArticlePages = function(q){
    var self = this;
    var url = cache.searchUrl + encodeURIComponent(q) + '&type=article&page=';

    return this.fetchJson(url + 1).then(function(first){
      var lastPage = Math.min(first.pages || 1, cache.maxArticlePages);
      var requests = [];

      for(var page = 2; page <= lastPage; page++){
        requests.push(self.fetchJson(url + page).then(function(data){
          return data.articles;
        }).catch(function(err){
          console.log(err);
          return [];
        }));
      }

      return Promise.all(requests).then(function(pages){
        var seen = {};
        return Array.prototype.concat.apply(first.articles, pages).filter(function(article){
          if(seen[article.id]) return false;
          seen[article.id] = true;
          return true;
        });
      });
    });
  }

  SearchAjax.prototype.fetchResult = function(q){
    var self = this;
    var onError = function(err){
      console.log(err);
      return [];
    };

    Promise.all([
      this.fetchJson(cache.searchUrl + encodeURIComponent(q) + '&type=product&page=1').then(function(data){
        return data.products;
      }).catch(onError),
      this.fetchArticles(q).catch(onError)
    ]).then(function(results){
      self.init({ products: results[0], articles: results[1] });
    }).catch(function(err){
      console.log(err);
    });
  }
  return SearchAjax;
})();

theme.AccountGeneralEvents = function(){
  var menuSelect = document.querySelector('[data-account-menu] [data-menu-select]');
  if(menuSelect){
    menuSelect.addEventListener('change', function(evt){
      window.location.href = this.value;
    });
  }

  var pswdInputs = document.querySelectorAll('[name*="password"]');
  if(pswdInputs && pswdInputs.length){
    pswdInputs.forEach(function(input){
        theme.Helpers.addListenerMulti(input,'focus blur', function(evt){
          if(evt.type === 'focus') this.placeholder = '';
          else this.placeholder = '•••••••••••••••';
        });
    });
  }
}

theme.adBlockCallBack = (function(){
  var adBlockCookieName = 'adb';
  var adblockCookie = theme.Helpers.getCookie(adBlockCookieName);
  var adBlockModal = document.querySelector('[data-addblock-modal]');
  if(adblockCookie && adblockCookie === 'adb_3'){
    if(adBlockModal) adBlockModal.remove();
    return;
  }

  var modalClose = adBlockModal.querySelector('[data-modal-close]');
  modalClose.addEventListener('click', function(evt){
    var adblockCookieCount = 1;
    if(adblockCookie){
      adblockCookieCount = adblockCookie.split('_')[1];
      if(!adblockCookieCount) adblockCookieCount = 1;
      adblockCookieCount = JSON.parse(adblockCookieCount);
      if(adblockCookieCount < 3) adblockCookieCount += 1;
      else adblockCookieCount = 3;
    }
    theme.Helpers.setCookie(adBlockCookieName,'adb_'+adblockCookieCount, 90);
    adBlockModal.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  });

  theme.Helpers.checkForAdBlocker(adBlockNotFoundCallBack, adBlockFoundCallBack);
  function adBlockNotFoundCallBack(){
    theme.Helpers.eraseCookie(adBlockCookieName);
  }
  function adBlockFoundCallBack(){
    if(adBlockModal){
      document.body.classList.add('overflow-hidden');
      adBlockModal.classList.remove('hidden');
    }
  }
})();

theme.init = function(){
  window.AjaxCart = new theme.AjaxCart();

  // ==================================
  var browserBack = document.querySelectorAll('.browser-back');
  if(browserBack && browserBack.length){
    browserBack.forEach(function(cta){
      cta.addEventListener('click', function(evt){
          evt.preventDefault();
          history.back();
      });
    });
  }
  // ==================================

  theme.AccountGeneralEvents();
}

document.addEventListener('DOMContentLoaded', function() {
    var sections = new theme.Sections();

    sections.register('contact-section', theme.Contact);
    sections.register('return-form-section', theme.ReturnForm);
    sections.register('section-glosar', theme.Glosar);
    sections.register('section-glosar-search', theme.Glosar);
    sections.register('section-article', theme.Article);
    sections.register('section-blog', theme.Blog);
    sections.register('login-template', theme.Login);
    sections.register('register-template', theme.RegisterLight);
    // sections.register('register-template', theme.Register); /* Has Fidelity Card form option */
    sections.register('fidelity-card-section', theme.FidelityCard);
    sections.register('loyalty-voucher-section', theme.LoyaltyVoucher);
    //sections.register('customer-account', theme.CustomerAccount);
    sections.register('customer-addresses', theme.CustomerAddresses);
    sections.register('customer-order', theme.CustomerOrder);
    sections.register('activate-account-template', theme.ActivateAccountOrResetPswd);
    sections.register('reset-password-template', theme.ActivateAccountOrResetPswd);
    sections.register('search-template', theme.SearchAjax);

    theme.init();
});
